export const topRopePath =
[
  {
      "x": 215.71796510473786,
      "y": 112.2613949131246
  },
  {
      "x": 220.12037255585497,
      "y": 110.06019109129863
  },
  {
      "x": 222.3215762814135,
      "y": 108.95958918038565
  },
  {
      "x": 223.4221781441928,
      "y": 108.95958918038565
  },
  {
      "x": 225.62338186975134,
      "y": 107.85898726947266
  },
  {
      "x": 227.82458559530988,
      "y": 106.75838535855968
  },
  {
      "x": 228.92518745808917,
      "y": 106.75838535855968
  },
  {
      "x": 230.02578932086845,
      "y": 106.75838535855968
  },
  {
      "x": 232.226993046427,
      "y": 104.5571815367337
  },
  {
      "x": 234.42819677198554,
      "y": 104.5571815367337
  },
  {
      "x": 234.42819677198554,
      "y": 103.45657962582071
  },
  {
      "x": 237.73000236032337,
      "y": 103.45657962582071
  },
  {
      "x": 237.73000236032337,
      "y": 103.45657962582071
  },
  {
      "x": 238.83060422310265,
      "y": 102.35597771490772
  },
  {
      "x": 242.13240981144048,
      "y": 102.35597771490772
  },
  {
      "x": 242.13240981144048,
      "y": 102.35597771490772
  },
  {
      "x": 243.23301167421974,
      "y": 102.35597771490772
  },
  {
      "x": 244.33361353699902,
      "y": 101.25537580399474
  },
  {
      "x": 245.43421539977828,
      "y": 101.25537580399474
  },
  {
      "x": 247.63541912533685,
      "y": 101.25537580399474
  },
  {
      "x": 249.8366228508954,
      "y": 101.25537580399474
  },
  {
      "x": 252.03782657645394,
      "y": 100.15477389308175
  },
  {
      "x": 255.33963216479177,
      "y": 99.05417198216877
  },
  {
      "x": 256.440234027571,
      "y": 99.05417198216877
  },
  {
      "x": 259.7420396159089,
      "y": 97.95357007125578
  },
  {
      "x": 259.7420396159089,
      "y": 97.95357007125578
  },
  {
      "x": 261.9432433414674,
      "y": 97.95357007125578
  },
  {
      "x": 264.14444706702596,
      "y": 97.95357007125578
  },
  {
      "x": 265.24504892980525,
      "y": 96.8529681603428
  },
  {
      "x": 266.34565079258454,
      "y": 95.75236624942981
  },
  {
      "x": 268.54685451814305,
      "y": 95.75236624942981
  },
  {
      "x": 269.64745638092234,
      "y": 95.75236624942981
  },
  {
      "x": 270.7480582437016,
      "y": 95.75236624942981
  },
  {
      "x": 272.9492619692602,
      "y": 95.75236624942981
  },
  {
      "x": 272.9492619692602,
      "y": 95.75236624942981
  },
  {
      "x": 275.1504656948187,
      "y": 95.75236624942981
  },
  {
      "x": 276.251067557598,
      "y": 95.75236624942981
  },
  {
      "x": 277.3516694203773,
      "y": 95.75236624942981
  },
  {
      "x": 277.3516694203773,
      "y": 95.75236624942981
  },
  {
      "x": 281.75407687149436,
      "y": 94.65176433851683
  },
  {
      "x": 282.85467873427365,
      "y": 93.55116242760384
  },
  {
      "x": 286.15648432261145,
      "y": 93.55116242760384
  },
  {
      "x": 288.35768804817,
      "y": 93.55116242760384
  },
  {
      "x": 290.55889177372853,
      "y": 93.55116242760384
  },
  {
      "x": 293.8606973620664,
      "y": 93.55116242760384
  },
  {
      "x": 294.9612992248457,
      "y": 93.55116242760384
  },
  {
      "x": 297.1625029504042,
      "y": 93.55116242760384
  },
  {
      "x": 299.36370667596276,
      "y": 93.55116242760384
  },
  {
      "x": 301.56491040152133,
      "y": 93.55116242760384
  },
  {
      "x": 303.76611412707985,
      "y": 93.55116242760384
  },
  {
      "x": 303.76611412707985,
      "y": 93.55116242760384
  },
  {
      "x": 304.86671598985913,
      "y": 93.55116242760384
  },
  {
      "x": 308.168521578197,
      "y": 93.55116242760384
  },
  {
      "x": 311.4703271665348,
      "y": 93.55116242760384
  },
  {
      "x": 314.7721327548726,
      "y": 93.55116242760384
  },
  {
      "x": 315.8727346176519,
      "y": 93.55116242760384
  },
  {
      "x": 316.97333648043116,
      "y": 93.55116242760384
  },
  {
      "x": 318.07393834321044,
      "y": 93.55116242760384
  },
  {
      "x": 319.17454020598973,
      "y": 93.55116242760384
  },
  {
      "x": 320.27514206876896,
      "y": 93.55116242760384
  },
  {
      "x": 321.37574393154824,
      "y": 93.55116242760384
  },
  {
      "x": 321.37574393154824,
      "y": 93.55116242760384
  },
  {
      "x": 322.47634579432753,
      "y": 93.55116242760384
  },
  {
      "x": 325.7781513826653,
      "y": 93.55116242760384
  },
  {
      "x": 327.9793551082239,
      "y": 93.55116242760384
  },
  {
      "x": 329.0799569710032,
      "y": 93.55116242760384
  },
  {
      "x": 332.381762559341,
      "y": 93.55116242760384
  },
  {
      "x": 334.58296628489956,
      "y": 93.55116242760384
  },
  {
      "x": 335.68356814767884,
      "y": 93.55116242760384
  },
  {
      "x": 337.88477187323736,
      "y": 93.55116242760384
  },
  {
      "x": 338.98537373601664,
      "y": 93.55116242760384
  },
  {
      "x": 340.0859755987959,
      "y": 93.55116242760384
  },
  {
      "x": 342.2871793243545,
      "y": 93.55116242760384
  },
  {
      "x": 343.3877811871338,
      "y": 93.55116242760384
  },
  {
      "x": 345.5889849126923,
      "y": 93.55116242760384
  },
  {
      "x": 347.79018863825087,
      "y": 93.55116242760384
  },
  {
      "x": 348.89079050103015,
      "y": 93.55116242760384
  },
  {
      "x": 351.09199422658867,
      "y": 93.55116242760384
  },
  {
      "x": 354.3937998149265,
      "y": 93.55116242760384
  },
  {
      "x": 355.49440167770575,
      "y": 93.55116242760384
  },
  {
      "x": 356.59500354048504,
      "y": 93.55116242760384
  },
  {
      "x": 358.7962072660436,
      "y": 93.55116242760384
  },
  {
      "x": 360.9974109916021,
      "y": 93.55116242760384
  },
  {
      "x": 362.0980128543814,
      "y": 93.55116242760384
  },
  {
      "x": 364.29921657994,
      "y": 93.55116242760384
  },
  {
      "x": 365.39981844271927,
      "y": 92.45056051669086
  },
  {
      "x": 367.6010221682778,
      "y": 92.45056051669086
  },
  {
      "x": 368.70162403105707,
      "y": 92.45056051669086
  },
  {
      "x": 369.80222589383635,
      "y": 92.45056051669086
  },
  {
      "x": 370.90282775661564,
      "y": 92.45056051669086
  },
  {
      "x": 372.0034296193949,
      "y": 92.45056051669086
  },
  {
      "x": 374.20463334495344,
      "y": 92.45056051669086
  },
  {
      "x": 376.405837070512,
      "y": 92.45056051669086
  },
  {
      "x": 377.5064389332913,
      "y": 92.45056051669086
  },
  {
      "x": 379.7076426588498,
      "y": 92.45056051669086
  },
  {
      "x": 385.2106519727462,
      "y": 92.45056051669086
  },
  {
      "x": 387.41185569830475,
      "y": 92.45056051669086
  },
  {
      "x": 388.51245756108403,
      "y": 92.45056051669086
  },
  {
      "x": 389.6130594238633,
      "y": 92.45056051669086
  },
  {
      "x": 391.81426314942183,
      "y": 92.45056051669086
  },
  {
      "x": 391.81426314942183,
      "y": 92.45056051669086
  },
  {
      "x": 392.9148650122011,
      "y": 92.45056051669086
  },
  {
      "x": 395.1160687377597,
      "y": 92.45056051669086
  },
  {
      "x": 396.2166706005389,
      "y": 92.45056051669086
  },
  {
      "x": 397.3172724633182,
      "y": 92.45056051669086
  },
  {
      "x": 400.61907805165606,
      "y": 92.45056051669086
  },
  {
      "x": 401.71967991443535,
      "y": 92.45056051669086
  },
  {
      "x": 402.8202817772146,
      "y": 92.45056051669086
  },
  {
      "x": 405.02148550277315,
      "y": 92.45056051669086
  },
  {
      "x": 408.32329109111095,
      "y": 93.55116242760384
  },
  {
      "x": 409.42389295389023,
      "y": 93.55116242760384
  },
  {
      "x": 411.6250966794488,
      "y": 93.55116242760384
  },
  {
      "x": 417.1281059933452,
      "y": 94.65176433851683
  },
  {
      "x": 418.22870785612446,
      "y": 94.65176433851683
  },
  {
      "x": 421.53051344446226,
      "y": 95.75236624942981
  },
  {
      "x": 425.93292089557934,
      "y": 95.75236624942981
  },
  {
      "x": 427.03352275835863,
      "y": 96.8529681603428
  },
  {
      "x": 427.03352275835863,
      "y": 97.95357007125578
  },
  {
      "x": 428.1341246211379,
      "y": 97.95357007125578
  },
  {
      "x": 430.3353283466965,
      "y": 97.95357007125578
  },
  {
      "x": 431.4359302094757,
      "y": 97.95357007125578
  },
  {
      "x": 432.536532072255,
      "y": 97.95357007125578
  },
  {
      "x": 434.73773579781357,
      "y": 99.05417198216877
  },
  {
      "x": 435.83833766059286,
      "y": 99.05417198216877
  },
  {
      "x": 438.03954138615137,
      "y": 100.15477389308175
  },
  {
      "x": 440.24074511170994,
      "y": 100.15477389308175
  },
  {
      "x": 442.4419488372685,
      "y": 101.25537580399474
  },
  {
      "x": 443.54255070004774,
      "y": 102.35597771490772
  },
  {
      "x": 446.8443562883856,
      "y": 102.35597771490772
  },
  {
      "x": 450.1461618767234,
      "y": 103.45657962582071
  },
  {
      "x": 452.34736560228197,
      "y": 103.45657962582071
  },
  {
      "x": 453.44796746506125,
      "y": 104.5571815367337
  },
  {
      "x": 456.74977305339905,
      "y": 104.5571815367337
  },
  {
      "x": 458.9509767789576,
      "y": 105.6577834476467
  },
  {
      "x": 467.7557916811918,
      "y": 107.85898726947266
  },
  {
      "x": 469.95699540675037,
      "y": 107.85898726947266
  },
  {
      "x": 471.05759726952965,
      "y": 107.85898726947266
  },
  {
      "x": 473.25880099508817,
      "y": 108.95958918038565
  },
  {
      "x": 474.35940285786745,
      "y": 108.95958918038565
  },
  {
      "x": 475.46000472064674,
      "y": 110.06019109129863
  },
  {
      "x": 478.76181030898454,
      "y": 110.06019109129863
  },
  {
      "x": 479.8624121717638,
      "y": 111.16079300221162
  },
  {
      "x": 480.9630140345431,
      "y": 111.16079300221162
  },
  {
      "x": 483.1642177601017,
      "y": 111.16079300221162
  },
  {
      "x": 484.26481962288096,
      "y": 111.16079300221162
  },
  {
      "x": 487.56662521121876,
      "y": 112.2613949131246
  },
  {
      "x": 488.66722707399805,
      "y": 112.2613949131246
  },
  {
      "x": 490.86843079955656,
      "y": 112.2613949131246
  },
  {
      "x": 491.96903266233585,
      "y": 112.2613949131246
  },
  {
      "x": 493.06963452511513,
      "y": 112.2613949131246
  },
  {
      "x": 496.37144011345293,
      "y": 113.36199682403759
  },
  {
      "x": 497.4720419762322,
      "y": 114.46259873495057
  },
  {
      "x": 500.7738475645701,
      "y": 114.46259873495057
  },
  {
      "x": 502.9750512901286,
      "y": 114.46259873495057
  },
  {
      "x": 506.27685687846645,
      "y": 115.56320064586356
  },
  {
      "x": 508.47806060402496,
      "y": 115.56320064586356
  },
  {
      "x": 510.67926432958353,
      "y": 115.56320064586356
  },
  {
      "x": 511.7798661923628,
      "y": 115.56320064586356
  },
  {
      "x": 513.9810699179213,
      "y": 116.66380255677655
  },
  {
      "x": 516.1822736434799,
      "y": 117.76440446768953
  },
  {
      "x": 519.4840792318178,
      "y": 118.86500637860252
  },
  {
      "x": 519.4840792318178,
      "y": 119.96560828951552
  },
  {
      "x": 521.6852829573763,
      "y": 119.96560828951552
  },
  {
      "x": 523.8864866829348,
      "y": 119.96560828951552
  },
  {
      "x": 524.9870885457141,
      "y": 121.0662102004285
  },
  {
      "x": 527.1882922712726,
      "y": 121.0662102004285
  },
  {
      "x": 528.2888941340519,
      "y": 121.0662102004285
  },
  {
      "x": 529.3894959968312,
      "y": 122.16681211134149
  },
  {
      "x": 532.6913015851691,
      "y": 123.26741402225447
  },
  {
      "x": 533.7919034479484,
      "y": 123.26741402225447
  },
  {
      "x": 541.4961164874032,
      "y": 124.36801593316746
  },
  {
      "x": 542.5967183501825,
      "y": 124.36801593316746
  },
  {
      "x": 546.9991258012996,
      "y": 124.36801593316746
  },
  {
      "x": 550.3009313896374,
      "y": 124.36801593316746
  },
  {
      "x": 553.6027369779753,
      "y": 125.46861784408044
  },
  {
      "x": 554.7033388407546,
      "y": 126.56921975499343
  },
  {
      "x": 555.8039407035338,
      "y": 126.56921975499343
  },
  {
      "x": 558.0051444290923,
      "y": 127.66982166590641
  },
  {
      "x": 559.1057462918716,
      "y": 127.66982166590641
  },
  {
      "x": 560.2063481546509,
      "y": 128.7704235768194
  },
  {
      "x": 562.4075518802094,
      "y": 128.7704235768194
  },
  {
      "x": 564.608755605768,
      "y": 129.8710254877324
  },
  {
      "x": 567.9105611941059,
      "y": 130.97162739864538
  },
  {
      "x": 570.1117649196643,
      "y": 130.97162739864538
  },
  {
      "x": 573.4135705080022,
      "y": 132.07222930955837
  },
  {
      "x": 576.71537609634,
      "y": 132.07222930955837
  },
  {
      "x": 580.0171816846779,
      "y": 132.07222930955837
  },
  {
      "x": 583.3189872730156,
      "y": 133.17283122047135
  },
  {
      "x": 586.6207928613535,
      "y": 133.17283122047135
  },
  {
      "x": 589.9225984496913,
      "y": 133.17283122047135
  },
  {
      "x": 591.0232003124706,
      "y": 133.17283122047135
  },
  {
      "x": 594.3250059008084,
      "y": 133.17283122047135
  },
  {
      "x": 595.4256077635877,
      "y": 133.17283122047135
  },
  {
      "x": 597.6268114891462,
      "y": 133.17283122047135
  },
  {
      "x": 599.8280152147048,
      "y": 133.17283122047135
  },
  {
      "x": 604.230422665822,
      "y": 134.27343313138434
  },
  {
      "x": 607.5322282541597,
      "y": 134.27343313138434
  },
  {
      "x": 610.8340338424975,
      "y": 134.27343313138434
  },
  {
      "x": 611.9346357052768,
      "y": 134.27343313138434
  },
  {
      "x": 615.2364412936147,
      "y": 134.27343313138434
  },
  {
      "x": 616.337043156394,
      "y": 134.27343313138434
  },
  {
      "x": 617.4376450191731,
      "y": 134.27343313138434
  },
  {
      "x": 619.6388487447317,
      "y": 134.27343313138434
  },
  {
      "x": 620.739450607511,
      "y": 134.27343313138434
  },
  {
      "x": 624.0412561958489,
      "y": 134.27343313138434
  },
  {
      "x": 626.2424599214074,
      "y": 134.27343313138434
  },
  {
      "x": 629.5442655097452,
      "y": 134.27343313138434
  },
  {
      "x": 632.846071098083,
      "y": 134.27343313138434
  },
  {
      "x": 633.9466729608623,
      "y": 134.27343313138434
  },
  {
      "x": 635.0472748236416,
      "y": 134.27343313138434
  },
  {
      "x": 638.3490804119795,
      "y": 134.27343313138434
  },
  {
      "x": 640.5502841375379,
      "y": 134.27343313138434
  },
  {
      "x": 642.7514878630965,
      "y": 134.27343313138434
  },
  {
      "x": 646.0532934514343,
      "y": 134.27343313138434
  },
  {
      "x": 649.3550990397722,
      "y": 134.27343313138434
  },
  {
      "x": 651.5563027653307,
      "y": 135.37403504229732
  },
  {
      "x": 654.8581083536685,
      "y": 135.37403504229732
  },
  {
      "x": 658.1599139420064,
      "y": 135.37403504229732
  },
  {
      "x": 661.4617195303442,
      "y": 135.37403504229732
  },
  {
      "x": 664.763525118682,
      "y": 135.37403504229732
  },
  {
      "x": 669.1659325697991,
      "y": 135.37403504229732
  },
  {
      "x": 670.2665344325784,
      "y": 135.37403504229732
  },
  {
      "x": 673.5683400209163,
      "y": 135.37403504229732
  },
  {
      "x": 675.7695437464747,
      "y": 135.37403504229732
  },
  {
      "x": 677.9707474720333,
      "y": 135.37403504229732
  },
  {
      "x": 681.2725530603711,
      "y": 135.37403504229732
  },
  {
      "x": 682.3731549231504,
      "y": 135.37403504229732
  },
  {
      "x": 686.7755623742676,
      "y": 135.37403504229732
  },
  {
      "x": 690.0773679626053,
      "y": 135.37403504229732
  },
  {
      "x": 692.2785716881639,
      "y": 135.37403504229732
  },
  {
      "x": 694.4797754137225,
      "y": 135.37403504229732
  },
  {
      "x": 696.680979139281,
      "y": 135.37403504229732
  },
  {
      "x": 699.9827847276188,
      "y": 135.37403504229732
  },
  {
      "x": 701.083386590398,
      "y": 135.37403504229732
  },
  {
      "x": 704.3851921787359,
      "y": 135.37403504229732
  },
  {
      "x": 707.6869977670738,
      "y": 135.37403504229732
  },
  {
      "x": 708.787599629853,
      "y": 135.37403504229732
  },
  {
      "x": 712.0894052181908,
      "y": 135.37403504229732
  },
  {
      "x": 714.2906089437494,
      "y": 135.37403504229732
  },
  {
      "x": 717.5924145320872,
      "y": 135.37403504229732
  },
  {
      "x": 718.6930163948665,
      "y": 135.37403504229732
  },
  {
      "x": 721.9948219832042,
      "y": 135.37403504229732
  },
  {
      "x": 723.0954238459835,
      "y": 135.37403504229732
  },
  {
      "x": 726.3972294343214,
      "y": 135.37403504229732
  },
  {
      "x": 728.59843315988,
      "y": 135.37403504229732
  },
  {
      "x": 730.7996368854385,
      "y": 135.37403504229732
  },
  {
      "x": 731.9002387482178,
      "y": 135.37403504229732
  },
  {
      "x": 735.2020443365556,
      "y": 135.37403504229732
  },
  {
      "x": 735.2020443365556,
      "y": 135.37403504229732
  },
  {
      "x": 738.5038499248934,
      "y": 135.37403504229732
  },
  {
      "x": 739.6044517876727,
      "y": 134.27343313138434
  },
  {
      "x": 744.0068592387898,
      "y": 133.17283122047135
  },
  {
      "x": 745.1074611015691,
      "y": 133.17283122047135
  },
  {
      "x": 748.4092666899069,
      "y": 133.17283122047135
  },
  {
      "x": 749.5098685526862,
      "y": 132.07222930955837
  },
  {
      "x": 751.7110722782447,
      "y": 130.97162739864538
  },
  {
      "x": 752.811674141024,
      "y": 129.8710254877324
  },
  {
      "x": 756.1134797293619,
      "y": 129.8710254877324
  },
  {
      "x": 758.3146834549203,
      "y": 128.7704235768194
  },
  {
      "x": 760.5158871804789,
      "y": 127.66982166590641
  },
  {
      "x": 762.7170909060375,
      "y": 127.66982166590641
  },
  {
      "x": 764.918294631596,
      "y": 127.66982166590641
  },
  {
      "x": 766.0188964943753,
      "y": 126.56921975499343
  },
  {
      "x": 767.1194983571546,
      "y": 125.46861784408044
  },
  {
      "x": 769.3207020827131,
      "y": 124.36801593316746
  },
  {
      "x": 770.4213039454924,
      "y": 124.36801593316746
  },
  {
      "x": 771.5219058082716,
      "y": 123.26741402225447
  },
  {
      "x": 772.6225076710509,
      "y": 121.0662102004285
  },
  {
      "x": 772.6225076710509,
      "y": 119.96560828951552
  },
  {
      "x": 773.7231095338302,
      "y": 119.96560828951552
  },
  {
      "x": 773.7231095338302,
      "y": 118.86500637860252
  },
  {
      "x": 773.7231095338302,
      "y": 115.56320064586356
  },
  {
      "x": 773.7231095338302,
      "y": 115.56320064586356
  },
  {
      "x": 773.7231095338302,
      "y": 114.46259873495057
  },
  {
      "x": 773.7231095338302,
      "y": 113.36199682403759
  },
  {
      "x": 773.7231095338302,
      "y": 111.16079300221162
  },
  {
      "x": 773.7231095338302,
      "y": 110.06019109129863
  },
  {
      "x": 772.6225076710509,
      "y": 108.95958918038565
  },
  {
      "x": 772.6225076710509,
      "y": 106.75838535855968
  },
  {
      "x": 771.5219058082716,
      "y": 104.5571815367337
  },
  {
      "x": 770.4213039454924,
      "y": 102.35597771490772
  },
  {
      "x": 770.4213039454924,
      "y": 101.25537580399474
  },
  {
      "x": 770.4213039454924,
      "y": 99.05417198216877
  },
  {
      "x": 770.4213039454924,
      "y": 97.95357007125578
  },
  {
      "x": 770.4213039454924,
      "y": 96.8529681603428
  },
  {
      "x": 770.4213039454924,
      "y": 94.65176433851683
  },
  {
      "x": 769.3207020827131,
      "y": 94.65176433851683
  },
  {
      "x": 769.3207020827131,
      "y": 93.55116242760384
  },
  {
      "x": 769.3207020827131,
      "y": 93.55116242760384
  },
  {
      "x": 769.3207020827131,
      "y": 92.45056051669086
  },
  {
      "x": 768.2201002199339,
      "y": 91.34995860577786
  },
  {
      "x": 766.0188964943753,
      "y": 89.14875478395189
  },
  {
      "x": 766.0188964943753,
      "y": 89.14875478395189
  },
  {
      "x": 766.0188964943753,
      "y": 88.0481528730389
  },
  {
      "x": 764.918294631596,
      "y": 85.84694905121293
  },
  {
      "x": 763.8176927688168,
      "y": 84.74634714029995
  },
  {
      "x": 763.8176927688168,
      "y": 84.74634714029995
  },
  {
      "x": 762.7170909060375,
      "y": 84.74634714029995
  },
  {
      "x": 761.6164890432582,
      "y": 83.64574522938696
  },
  {
      "x": 761.6164890432582,
      "y": 82.54514331847398
  },
  {
      "x": 760.5158871804789,
      "y": 81.44454140756099
  },
  {
      "x": 759.4152853176996,
      "y": 81.44454140756099
  },
  {
      "x": 758.3146834549203,
      "y": 80.343939496648
  },
  {
      "x": 757.2140815921412,
      "y": 80.343939496648
  },
  {
      "x": 755.0128778665826,
      "y": 79.24333758573502
  },
  {
      "x": 753.9122760038033,
      "y": 78.14273567482203
  },
  {
      "x": 751.7110722782447,
      "y": 78.14273567482203
  },
  {
      "x": 749.5098685526862,
      "y": 77.04213376390904
  },
  {
      "x": 748.4092666899069,
      "y": 75.94153185299605
  },
  {
      "x": 746.2080629643483,
      "y": 75.94153185299605
  },
  {
      "x": 744.0068592387898,
      "y": 73.74032803117008
  },
  {
      "x": 741.8056555132313,
      "y": 72.6397261202571
  },
  {
      "x": 739.6044517876727,
      "y": 72.6397261202571
  },
  {
      "x": 738.5038499248934,
      "y": 71.53912420934411
  },
  {
      "x": 735.2020443365556,
      "y": 71.53912420934411
  },
  {
      "x": 735.2020443365556,
      "y": 71.53912420934411
  },
  {
      "x": 731.9002387482178,
      "y": 71.53912420934411
  },
  {
      "x": 730.7996368854385,
      "y": 71.53912420934411
  },
  {
      "x": 728.59843315988,
      "y": 71.53912420934411
  },
  {
      "x": 725.2966275715421,
      "y": 71.53912420934411
  },
  {
      "x": 721.9948219832042,
      "y": 71.53912420934411
  },
  {
      "x": 720.8942201204251,
      "y": 71.53912420934411
  },
  {
      "x": 717.5924145320872,
      "y": 71.53912420934411
  },
  {
      "x": 713.1900070809701,
      "y": 71.53912420934411
  },
  {
      "x": 710.9888033554115,
      "y": 71.53912420934411
  },
  {
      "x": 708.787599629853,
      "y": 71.53912420934411
  },
  {
      "x": 705.4857940415152,
      "y": 71.53912420934411
  },
  {
      "x": 702.1839884531773,
      "y": 71.53912420934411
  },
  {
      "x": 699.9827847276188,
      "y": 71.53912420934411
  },
  {
      "x": 697.7815810020603,
      "y": 71.53912420934411
  },
  {
      "x": 695.5803772765017,
      "y": 71.53912420934411
  },
  {
      "x": 693.3791735509432,
      "y": 71.53912420934411
  },
  {
      "x": 687.8761642370467,
      "y": 71.53912420934411
  },
  {
      "x": 686.7755623742676,
      "y": 71.53912420934411
  },
  {
      "x": 683.4737567859297,
      "y": 71.53912420934411
  },
  {
      "x": 679.0713493348126,
      "y": 71.53912420934411
  },
  {
      "x": 676.870145609254,
      "y": 71.53912420934411
  },
  {
      "x": 674.6689418836955,
      "y": 71.53912420934411
  },
  {
      "x": 672.467738158137,
      "y": 72.6397261202571
  },
  {
      "x": 669.1659325697991,
      "y": 74.84092994208306
  },
  {
      "x": 664.763525118682,
      "y": 74.84092994208306
  },
  {
      "x": 658.1599139420064,
      "y": 75.94153185299605
  },
  {
      "x": 657.0593120792271,
      "y": 75.94153185299605
  },
  {
      "x": 654.8581083536685,
      "y": 77.04213376390904
  },
  {
      "x": 651.5563027653307,
      "y": 78.14273567482203
  },
  {
      "x": 648.2544971769929,
      "y": 79.24333758573502
  },
  {
      "x": 647.1538953142136,
      "y": 79.24333758573502
  },
  {
      "x": 643.8520897258758,
      "y": 80.343939496648
  },
  {
      "x": 641.6508860003172,
      "y": 80.343939496648
  },
  {
      "x": 639.4496822747587,
      "y": 80.343939496648
  },
  {
      "x": 636.1478766864209,
      "y": 81.44454140756099
  },
  {
      "x": 633.9466729608623,
      "y": 81.44454140756099
  },
  {
      "x": 629.5442655097452,
      "y": 82.54514331847398
  },
  {
      "x": 628.4436636469659,
      "y": 82.54514331847398
  },
  {
      "x": 625.1418580586281,
      "y": 83.64574522938696
  },
  {
      "x": 622.9406543330696,
      "y": 83.64574522938696
  },
  {
      "x": 620.739450607511,
      "y": 84.74634714029995
  },
  {
      "x": 619.6388487447317,
      "y": 84.74634714029995
  },
  {
      "x": 616.337043156394,
      "y": 84.74634714029995
  },
  {
      "x": 615.2364412936147,
      "y": 84.74634714029995
  },
  {
      "x": 611.9346357052768,
      "y": 84.74634714029995
  },
  {
      "x": 610.8340338424975,
      "y": 84.74634714029995
  },
  {
      "x": 608.632830116939,
      "y": 84.74634714029995
  },
  {
      "x": 607.5322282541597,
      "y": 84.74634714029995
  },
  {
      "x": 604.230422665822,
      "y": 85.84694905121293
  },
  {
      "x": 602.0292189402634,
      "y": 86.94755096212592
  },
  {
      "x": 598.7274133519255,
      "y": 86.94755096212592
  },
  {
      "x": 596.526209626367,
      "y": 88.0481528730389
  },
  {
      "x": 594.3250059008084,
      "y": 88.0481528730389
  },
  {
      "x": 589.9225984496913,
      "y": 89.14875478395189
  },
  {
      "x": 587.7213947241328,
      "y": 89.14875478395189
  },
  {
      "x": 585.5201909985742,
      "y": 89.14875478395189
  },
  {
      "x": 582.2183854102364,
      "y": 89.14875478395189
  },
  {
      "x": 578.9165798218986,
      "y": 89.14875478395189
  },
  {
      "x": 576.71537609634,
      "y": 90.24935669486487
  },
  {
      "x": 575.6147742335608,
      "y": 90.24935669486487
  },
  {
      "x": 567.9105611941059,
      "y": 90.24935669486487
  },
  {
      "x": 565.7093574685473,
      "y": 91.34995860577786
  },
  {
      "x": 563.5081537429887,
      "y": 92.45056051669086
  },
  {
      "x": 561.3069500174302,
      "y": 92.45056051669086
  },
  {
      "x": 559.1057462918716,
      "y": 93.55116242760384
  },
  {
      "x": 556.9045425663131,
      "y": 93.55116242760384
  },
  {
      "x": 554.7033388407546,
      "y": 93.55116242760384
  },
  {
      "x": 552.502135115196,
      "y": 94.65176433851683
  },
  {
      "x": 550.3009313896374,
      "y": 95.75236624942981
  },
  {
      "x": 546.9991258012996,
      "y": 96.8529681603428
  },
  {
      "x": 545.8985239385204,
      "y": 97.95357007125578
  },
  {
      "x": 544.7979220757411,
      "y": 97.95357007125578
  },
  {
      "x": 541.4961164874032,
      "y": 97.95357007125578
  },
  {
      "x": 541.4961164874032,
      "y": 99.05417198216877
  },
  {
      "x": 540.395514624624,
      "y": 100.15477389308175
  },
  {
      "x": 538.1943108990654,
      "y": 100.15477389308175
  },
  {
      "x": 537.0937090362861,
      "y": 101.25537580399474
  },
  {
      "x": 534.8925053107275,
      "y": 102.35597771490772
  },
  {
      "x": 532.6913015851691,
      "y": 103.45657962582071
  },
  {
      "x": 530.4900978596105,
      "y": 104.5571815367337
  },
  {
      "x": 528.2888941340519,
      "y": 105.6577834476467
  },
  {
      "x": 523.8864866829348,
      "y": 106.75838535855968
  },
  {
      "x": 521.6852829573763,
      "y": 107.85898726947266
  },
  {
      "x": 519.4840792318178,
      "y": 107.85898726947266
  },
  {
      "x": 517.2828755062592,
      "y": 108.95958918038565
  },
  {
      "x": 513.9810699179213,
      "y": 111.16079300221162
  },
  {
      "x": 510.67926432958353,
      "y": 112.2613949131246
  },
  {
      "x": 510.67926432958353,
      "y": 112.2613949131246
  },
  {
      "x": 508.47806060402496,
      "y": 113.36199682403759
  },
  {
      "x": 504.0756531529079,
      "y": 115.56320064586356
  },
  {
      "x": 501.8744494273493,
      "y": 115.56320064586356
  },
  {
      "x": 498.5726438390115,
      "y": 116.66380255677655
  },
  {
      "x": 496.37144011345293,
      "y": 118.86500637860252
  },
  {
      "x": 493.06963452511513,
      "y": 119.96560828951552
  },
  {
      "x": 490.86843079955656,
      "y": 119.96560828951552
  },
  {
      "x": 487.56662521121876,
      "y": 121.0662102004285
  },
  {
      "x": 485.3654214856602,
      "y": 122.16681211134149
  },
  {
      "x": 483.1642177601017,
      "y": 123.26741402225447
  },
  {
      "x": 482.0636158973224,
      "y": 123.26741402225447
  },
  {
      "x": 479.8624121717638,
      "y": 124.36801593316746
  },
  {
      "x": 477.6612084462053,
      "y": 124.36801593316746
  },
  {
      "x": 474.35940285786745,
      "y": 124.36801593316746
  },
  {
      "x": 473.25880099508817,
      "y": 125.46861784408044
  },
  {
      "x": 471.05759726952965,
      "y": 125.46861784408044
  },
  {
      "x": 467.7557916811918,
      "y": 126.56921975499343
  },
  {
      "x": 466.6551898184125,
      "y": 127.66982166590641
  },
  {
      "x": 463.3533842300747,
      "y": 128.7704235768194
  },
  {
      "x": 461.15218050451614,
      "y": 128.7704235768194
  },
  {
      "x": 452.34736560228197,
      "y": 129.8710254877324
  },
  {
      "x": 446.8443562883856,
      "y": 133.17283122047135
  },
  {
      "x": 444.643152562827,
      "y": 133.17283122047135
  },
  {
      "x": 442.4419488372685,
      "y": 133.17283122047135
  },
  {
      "x": 440.24074511170994,
      "y": 133.17283122047135
  },
  {
      "x": 436.93893952337214,
      "y": 133.17283122047135
  },
  {
      "x": 434.73773579781357,
      "y": 134.27343313138434
  },
  {
      "x": 434.73773579781357,
      "y": 135.37403504229732
  },
  {
      "x": 431.4359302094757,
      "y": 136.4746369532103
  },
  {
      "x": 431.4359302094757,
      "y": 137.5752388641233
  },
  {
      "x": 427.03352275835863,
      "y": 137.5752388641233
  },
  {
      "x": 424.8323190328001,
      "y": 137.5752388641233
  },
  {
      "x": 421.53051344446226,
      "y": 139.77644268594926
  },
  {
      "x": 418.22870785612446,
      "y": 139.77644268594926
  },
  {
      "x": 413.8263004050074,
      "y": 141.97764650777523
  },
  {
      "x": 410.5244948166695,
      "y": 141.97764650777523
  },
  {
      "x": 407.2226892283317,
      "y": 141.97764650777523
  },
  {
      "x": 402.8202817772146,
      "y": 145.2794522405142
  },
  {
      "x": 400.61907805165606,
      "y": 146.38005415142717
  },
  {
      "x": 397.3172724633182,
      "y": 146.38005415142717
  },
  {
      "x": 396.2166706005389,
      "y": 146.38005415142717
  },
  {
      "x": 387.41185569830475,
      "y": 150.78246179507912
  },
  {
      "x": 383.00944824718766,
      "y": 150.78246179507912
  },
  {
      "x": 378.6070407960706,
      "y": 151.8830637059921
  },
  {
      "x": 377.5064389332913,
      "y": 152.98366561690509
  },
  {
      "x": 375.3052352077327,
      "y": 152.98366561690509
  },
  {
      "x": 374.20463334495344,
      "y": 155.18486943873108
  },
  {
      "x": 373.10403148217415,
      "y": 155.18486943873108
  },
  {
      "x": 372.0034296193949,
      "y": 155.18486943873108
  },
  {
      "x": 369.80222589383635,
      "y": 155.18486943873108
  },
  {
      "x": 366.50042030549855,
      "y": 157.38607326055705
  },
  {
      "x": 365.39981844271927,
      "y": 157.38607326055705
  },
  {
      "x": 362.0980128543814,
      "y": 159.58727708238303
  },
  {
      "x": 358.7962072660436,
      "y": 160.687878993296
  },
  {
      "x": 352.19259608936795,
      "y": 162.88908281512198
  },
  {
      "x": 351.09199422658867,
      "y": 163.98968472603497
  },
  {
      "x": 348.89079050103015,
      "y": 163.98968472603497
  },
  {
      "x": 346.6895867754716,
      "y": 165.09028663694795
  },
  {
      "x": 343.3877811871338,
      "y": 167.29149045877392
  },
  {
      "x": 341.1865774615752,
      "y": 167.29149045877392
  },
  {
      "x": 340.0859755987959,
      "y": 167.29149045877392
  },
  {
      "x": 337.88477187323736,
      "y": 168.3920923696869
  },
  {
      "x": 335.68356814767884,
      "y": 168.3920923696869
  },
  {
      "x": 333.48236442212027,
      "y": 168.3920923696869
  },
  {
      "x": 331.28116069656176,
      "y": 168.3920923696869
  },
  {
      "x": 326.8787532454446,
      "y": 170.59329619151288
  },
  {
      "x": 324.6775495198861,
      "y": 171.69389810242586
  },
  {
      "x": 321.37574393154824,
      "y": 171.69389810242586
  },
  {
      "x": 318.07393834321044,
      "y": 171.69389810242586
  },
  {
      "x": 315.8727346176519,
      "y": 172.79450001333885
  },
  {
      "x": 312.5709290293141,
      "y": 172.79450001333885
  },
  {
      "x": 311.4703271665348,
      "y": 172.79450001333885
  },
  {
      "x": 308.168521578197,
      "y": 173.89510192425183
  },
  {
      "x": 307.0679197154177,
      "y": 173.89510192425183
  },
  {
      "x": 304.86671598985913,
      "y": 174.99570383516482
  },
  {
      "x": 303.76611412707985,
      "y": 176.0963057460778
  },
  {
      "x": 301.56491040152133,
      "y": 177.1969076569908
  },
  {
      "x": 297.1625029504042,
      "y": 177.1969076569908
  },
  {
      "x": 292.7600954992871,
      "y": 178.29750956790377
  },
  {
      "x": 290.55889177372853,
      "y": 178.29750956790377
  },
  {
      "x": 288.35768804817,
      "y": 178.29750956790377
  },
  {
      "x": 286.15648432261145,
      "y": 179.39811147881676
  },
  {
      "x": 285.05588245983216,
      "y": 179.39811147881676
  },
  {
      "x": 282.85467873427365,
      "y": 180.49871338972974
  },
  {
      "x": 280.6534750087151,
      "y": 180.49871338972974
  },
  {
      "x": 277.3516694203773,
      "y": 181.59931530064273
  },
  {
      "x": 272.9492619692602,
      "y": 181.59931530064273
  },
  {
      "x": 271.8486601064809,
      "y": 181.59931530064273
  },
  {
      "x": 268.54685451814305,
      "y": 182.69991721155571
  },
  {
      "x": 264.14444706702596,
      "y": 182.69991721155571
  },
  {
      "x": 260.84264147868817,
      "y": 183.80051912246873
  },
  {
      "x": 259.7420396159089,
      "y": 183.80051912246873
  },
  {
      "x": 252.03782657645394,
      "y": 186.0017229442947
  },
  {
      "x": 250.93722471367465,
      "y": 186.0017229442947
  },
  {
      "x": 248.7360209881161,
      "y": 186.0017229442947
  },
  {
      "x": 247.63541912533685,
      "y": 186.0017229442947
  },
  {
      "x": 246.53481726255757,
      "y": 187.10232485520768
  },
  {
      "x": 245.43421539977828,
      "y": 187.10232485520768
  },
  {
      "x": 243.23301167421974,
      "y": 188.20292676612067
  },
  {
      "x": 242.13240981144048,
      "y": 188.20292676612067
  },
  {
      "x": 238.83060422310265,
      "y": 189.30352867703365
  },
  {
      "x": 234.42819677198554,
      "y": 190.40413058794664
  },
  {
      "x": 232.226993046427,
      "y": 190.40413058794664
  },
  {
      "x": 228.92518745808917,
      "y": 190.40413058794664
  },
  {
      "x": 228.92518745808917,
      "y": 191.50473249885962
  },
  {
      "x": 224.52278000697208,
      "y": 192.6053344097726
  },
  {
      "x": 222.3215762814135,
      "y": 192.6053344097726
  },
  {
      "x": 221.22097441863426,
      "y": 192.6053344097726
  },
  {
      "x": 219.01977069307569,
      "y": 192.6053344097726
  },
  {
      "x": 217.91916883029643,
      "y": 192.6053344097726
  },
  {
      "x": 215.71796510473786,
      "y": 192.6053344097726
  },
  {
      "x": 212.41615951640006,
      "y": 192.6053344097726
  },
  {
      "x": 209.11435392806223,
      "y": 193.7059363206856
  },
  {
      "x": 206.9131502025037,
      "y": 193.7059363206856
  },
  {
      "x": 204.71194647694512,
      "y": 193.7059363206856
  },
  {
      "x": 202.51074275138657,
      "y": 194.80653823159858
  },
  {
      "x": 201.4101408886073,
      "y": 194.80653823159858
  },
  {
      "x": 200.30953902582803,
      "y": 194.80653823159858
  },
  {
      "x": 199.20893716304874,
      "y": 194.80653823159858
  },
  {
      "x": 198.10833530026946,
      "y": 194.80653823159858
  },
  {
      "x": 197.0077334374902,
      "y": 194.80653823159858
  },
  {
      "x": 193.70592784915237,
      "y": 194.80653823159858
  },
  {
      "x": 189.3035203980353,
      "y": 194.80653823159858
  },
  {
      "x": 187.10231667247672,
      "y": 194.80653823159858
  },
  {
      "x": 184.90111294691818,
      "y": 194.80653823159858
  },
  {
      "x": 181.59930735858035,
      "y": 194.80653823159858
  },
  {
      "x": 180.49870549580106,
      "y": 194.80653823159858
  },
  {
      "x": 179.3981036330218,
      "y": 194.80653823159858
  },
  {
      "x": 177.19689990746326,
      "y": 194.80653823159858
  },
  {
      "x": 173.89509431912543,
      "y": 194.80653823159858
  },
  {
      "x": 172.79449245634615,
      "y": 194.80653823159858
  },
  {
      "x": 170.5932887307876,
      "y": 194.80653823159858
  },
  {
      "x": 167.29148314244978,
      "y": 193.7059363206856
  },
  {
      "x": 166.1908812796705,
      "y": 193.7059363206856
  },
  {
      "x": 163.98967755411195,
      "y": 193.7059363206856
  },
  {
      "x": 161.7884738285534,
      "y": 193.7059363206856
  },
  {
      "x": 158.48666824021558,
      "y": 193.7059363206856
  },
  {
      "x": 158.48666824021558,
      "y": 193.7059363206856
  },
  {
      "x": 156.28546451465704,
      "y": 193.7059363206856
  },
  {
      "x": 154.0842607890985,
      "y": 193.7059363206856
  },
  {
      "x": 152.9836589263192,
      "y": 193.7059363206856
  },
  {
      "x": 150.78245520076067,
      "y": 193.7059363206856
  },
  {
      "x": 147.48064961242284,
      "y": 193.7059363206856
  },
  {
      "x": 146.38004774964355,
      "y": 193.7059363206856
  },
  {
      "x": 145.27944588686427,
      "y": 193.7059363206856
  },
  {
      "x": 141.97764029852647,
      "y": 193.7059363206856
  },
  {
      "x": 140.87703843574718,
      "y": 193.7059363206856
  },
  {
      "x": 139.7764365729679,
      "y": 192.6053344097726
  },
  {
      "x": 138.67583471018864,
      "y": 192.6053344097726
  },
  {
      "x": 136.4746309846301,
      "y": 191.50473249885962
  },
  {
      "x": 136.4746309846301,
      "y": 191.50473249885962
  },
  {
      "x": 135.3740291218508,
      "y": 190.40413058794664
  },
  {
      "x": 133.17282539629227,
      "y": 190.40413058794664
  },
  {
      "x": 132.07222353351298,
      "y": 189.30352867703365
  },
  {
      "x": 132.07222353351298,
      "y": 188.20292676612067
  },
  {
      "x": 130.9716216707337,
      "y": 187.10232485520768
  },
  {
      "x": 129.87101980795444,
      "y": 186.0017229442947
  },
  {
      "x": 128.77041794517515,
      "y": 184.9011210333817
  },
  {
      "x": 128.77041794517515,
      "y": 182.69991721155571
  },
  {
      "x": 127.66981608239588,
      "y": 181.59931530064273
  },
  {
      "x": 127.66981608239588,
      "y": 180.49871338972974
  },
  {
      "x": 127.66981608239588,
      "y": 179.39811147881676
  },
  {
      "x": 127.66981608239588,
      "y": 177.1969076569908
  },
  {
      "x": 128.77041794517515,
      "y": 177.1969076569908
  },
  {
      "x": 129.87101980795444,
      "y": 177.1969076569908
  },
  {
      "x": 129.87101980795444,
      "y": 176.0963057460778
  },
  {
      "x": 129.87101980795444,
      "y": 174.99570383516482
  },
  {
      "x": 130.9716216707337,
      "y": 173.89510192425183
  },
  {
      "x": 132.07222353351298,
      "y": 173.89510192425183
  },
  {
      "x": 132.07222353351298,
      "y": 172.79450001333885
  },
  {
      "x": 132.07222353351298,
      "y": 172.79450001333885
  },
  {
      "x": 133.17282539629227,
      "y": 171.69389810242586
  },
  {
      "x": 135.3740291218508,
      "y": 170.59329619151288
  },
  {
      "x": 135.3740291218508,
      "y": 169.4926942805999
  },
  {
      "x": 136.4746309846301,
      "y": 168.3920923696869
  },
  {
      "x": 137.57523284740935,
      "y": 168.3920923696869
  },
  {
      "x": 138.67583471018864,
      "y": 168.3920923696869
  },
  {
      "x": 139.7764365729679,
      "y": 167.29149045877392
  },
  {
      "x": 140.87703843574718,
      "y": 167.29149045877392
  },
  {
      "x": 140.87703843574718,
      "y": 165.09028663694795
  },
  {
      "x": 143.07824216130572,
      "y": 165.09028663694795
  },
  {
      "x": 144.178844024085,
      "y": 165.09028663694795
  },
  {
      "x": 145.27944588686427,
      "y": 165.09028663694795
  },
  {
      "x": 149.68185333798138,
      "y": 163.98968472603497
  },
  {
      "x": 154.0842607890985,
      "y": 162.88908281512198
  },
  {
      "x": 156.28546451465704,
      "y": 162.88908281512198
  },
  {
      "x": 158.48666824021558,
      "y": 161.788480904209
  },
  {
      "x": 160.68787196577412,
      "y": 161.788480904209
  },
  {
      "x": 161.7884738285534,
      "y": 161.788480904209
  },
  {
      "x": 162.88907569133266,
      "y": 161.788480904209
  },
  {
      "x": 162.88907569133266,
      "y": 160.687878993296
  },
  {
      "x": 163.98967755411195,
      "y": 160.687878993296
  },
  {
      "x": 165.09027941689124,
      "y": 159.58727708238303
  },
  {
      "x": 166.1908812796705,
      "y": 159.58727708238303
  },
  {
      "x": 167.29148314244978,
      "y": 159.58727708238303
  },
  {
      "x": 167.29148314244978,
      "y": 159.58727708238303
  },
  {
      "x": 167.29148314244978,
      "y": 159.58727708238303
  },
  {
      "x": 168.39208500522906,
      "y": 159.58727708238303
  },
  {
      "x": 169.49268686800832,
      "y": 159.58727708238303
  },
  {
      "x": 170.5932887307876,
      "y": 159.58727708238303
  },
  {
      "x": 171.6938905935669,
      "y": 159.58727708238303
  },
  {
      "x": 172.79449245634615,
      "y": 158.48667517147004
  },
  {
      "x": 174.9956961819047,
      "y": 158.48667517147004
  },
  {
      "x": 177.19689990746326,
      "y": 158.48667517147004
  },
  {
      "x": 183.8005110841389,
      "y": 157.38607326055705
  },
  {
      "x": 188.202918535256,
      "y": 157.38607326055705
  },
  {
      "x": 198.10833530026946,
      "y": 157.38607326055705
  },
  {
      "x": 199.20893716304874,
      "y": 157.38607326055705
  },
  {
      "x": 200.30953902582803,
      "y": 157.38607326055705
  },
  {
      "x": 201.4101408886073,
      "y": 157.38607326055705
  },
  {
      "x": 202.51074275138657,
      "y": 157.38607326055705
  },
  {
      "x": 202.51074275138657,
      "y": 157.38607326055705
  },
  {
      "x": 205.8125483397244,
      "y": 157.38607326055705
  },
  {
      "x": 209.11435392806223,
      "y": 157.38607326055705
  },
  {
      "x": 210.2149557908415,
      "y": 157.38607326055705
  },
  {
      "x": 213.51676137917931,
      "y": 157.38607326055705
  },
  {
      "x": 215.71796510473786,
      "y": 157.38607326055705
  },
  {
      "x": 215.71796510473786,
      "y": 157.38607326055705
  },
  {
      "x": 216.81856696751714,
      "y": 157.38607326055705
  },
  {
      "x": 217.91916883029643,
      "y": 157.38607326055705
  },
  {
      "x": 219.01977069307569,
      "y": 157.38607326055705
  },
  {
      "x": 220.12037255585497,
      "y": 157.38607326055705
  },
  {
      "x": 221.22097441863426,
      "y": 157.38607326055705
  },
  {
      "x": 222.3215762814135,
      "y": 158.48667517147004
  },
  {
      "x": 224.52278000697208,
      "y": 158.48667517147004
  },
  {
      "x": 227.82458559530988,
      "y": 159.58727708238303
  },
  {
      "x": 228.92518745808917,
      "y": 159.58727708238303
  },
  {
      "x": 228.92518745808917,
      "y": 159.58727708238303
  },
  {
      "x": 230.02578932086845,
      "y": 159.58727708238303
  },
  {
      "x": 233.32759490920625,
      "y": 161.788480904209
  },
  {
      "x": 236.62940049754408,
      "y": 162.88908281512198
  },
  {
      "x": 237.73000236032337,
      "y": 162.88908281512198
  },
  {
      "x": 242.13240981144048,
      "y": 162.88908281512198
  },
  {
      "x": 244.33361353699902,
      "y": 163.98968472603497
  },
  {
      "x": 245.43421539977828,
      "y": 163.98968472603497
  },
  {
      "x": 246.53481726255757,
      "y": 163.98968472603497
  },
  {
      "x": 246.53481726255757,
      "y": 163.98968472603497
  },
  {
      "x": 247.63541912533685,
      "y": 163.98968472603497
  },
  {
      "x": 248.7360209881161,
      "y": 163.98968472603497
  },
  {
      "x": 250.93722471367465,
      "y": 163.98968472603497
  },
  {
      "x": 250.93722471367465,
      "y": 163.98968472603497
  },
  {
      "x": 252.03782657645394,
      "y": 163.98968472603497
  },
  {
      "x": 253.13842843923322,
      "y": 165.09028663694795
  },
  {
      "x": 254.23903030201248,
      "y": 165.09028663694795
  },
  {
      "x": 254.23903030201248,
      "y": 166.19088854786094
  },
  {
      "x": 255.33963216479177,
      "y": 166.19088854786094
  },
  {
      "x": 255.33963216479177,
      "y": 166.19088854786094
  },
  {
      "x": 256.440234027571,
      "y": 166.19088854786094
  },
  {
      "x": 259.7420396159089,
      "y": 167.29149045877392
  },
  {
      "x": 261.9432433414674,
      "y": 168.3920923696869
  },
  {
      "x": 263.0438452042467,
      "y": 168.3920923696869
  },
  {
      "x": 265.24504892980525,
      "y": 169.4926942805999
  },
  {
      "x": 266.34565079258454,
      "y": 169.4926942805999
  },
  {
      "x": 267.44625265536376,
      "y": 169.4926942805999
  },
  {
      "x": 268.54685451814305,
      "y": 170.59329619151288
  },
  {
      "x": 269.64745638092234,
      "y": 171.69389810242586
  },
  {
      "x": 270.7480582437016,
      "y": 171.69389810242586
  },
  {
      "x": 271.8486601064809,
      "y": 172.79450001333885
  },
  {
      "x": 272.9492619692602,
      "y": 172.79450001333885
  },
  {
      "x": 274.0498638320394,
      "y": 172.79450001333885
  },
  {
      "x": 275.1504656948187,
      "y": 173.89510192425183
  },
  {
      "x": 276.251067557598,
      "y": 173.89510192425183
  },
  {
      "x": 277.3516694203773,
      "y": 173.89510192425183
  },
  {
      "x": 278.45227128315656,
      "y": 176.0963057460778
  },
  {
      "x": 279.5528731459358,
      "y": 176.0963057460778
  },
  {
      "x": 279.5528731459358,
      "y": 177.1969076569908
  },
  {
      "x": 281.75407687149436,
      "y": 177.1969076569908
  },
  {
      "x": 282.85467873427365,
      "y": 177.1969076569908
  },
  {
      "x": 282.85467873427365,
      "y": 178.29750956790377
  },
  {
      "x": 285.05588245983216,
      "y": 180.49871338972974
  },
  {
      "x": 286.15648432261145,
      "y": 180.49871338972974
  },
  {
      "x": 287.25708618539073,
      "y": 181.59931530064273
  },
  {
      "x": 289.4582899109493,
      "y": 182.69991721155571
  },
  {
      "x": 290.55889177372853,
      "y": 183.80051912246873
  },
  {
      "x": 291.6594936365078,
      "y": 186.0017229442947
  },
  {
      "x": 293.8606973620664,
      "y": 186.0017229442947
  },
  {
      "x": 294.9612992248457,
      "y": 186.0017229442947
  },
  {
      "x": 294.9612992248457,
      "y": 187.10232485520768
  },
  {
      "x": 296.06190108762496,
      "y": 188.20292676612067
  },
  {
      "x": 297.1625029504042,
      "y": 188.20292676612067
  },
  {
      "x": 298.2631048131835,
      "y": 189.30352867703365
  },
  {
      "x": 298.2631048131835,
      "y": 190.40413058794664
  },
  {
      "x": 299.36370667596276,
      "y": 190.40413058794664
  },
  {
      "x": 299.36370667596276,
      "y": 190.40413058794664
  },
  {
      "x": 299.36370667596276,
      "y": 191.50473249885962
  },
  {
      "x": 300.46430853874205,
      "y": 192.6053344097726
  },
  {
      "x": 301.56491040152133,
      "y": 192.6053344097726
  },
  {
      "x": 302.66551226430056,
      "y": 194.80653823159858
  },
  {
      "x": 303.76611412707985,
      "y": 195.90714014251157
  },
  {
      "x": 303.76611412707985,
      "y": 195.90714014251157
  },
  {
      "x": 304.86671598985913,
      "y": 197.00774205342455
  },
  {
      "x": 304.86671598985913,
      "y": 199.20894587525052
  },
  {
      "x": 305.9673178526384,
      "y": 199.20894587525052
  },
  {
      "x": 305.9673178526384,
      "y": 200.3095477861635
  },
  {
      "x": 307.0679197154177,
      "y": 202.51075160798948
  },
  {
      "x": 308.168521578197,
      "y": 202.51075160798948
  },
  {
      "x": 308.168521578197,
      "y": 203.61135351890246
  },
  {
      "x": 309.2691234409762,
      "y": 204.71195542981545
  },
  {
      "x": 310.3697253037555,
      "y": 206.91315925164142
  },
  {
      "x": 310.3697253037555,
      "y": 208.0137611625544
  },
  {
      "x": 311.4703271665348,
      "y": 208.0137611625544
  },
  {
      "x": 311.4703271665348,
      "y": 209.1143630734674
  },
  {
      "x": 311.4703271665348,
      "y": 211.3155668952934
  },
  {
      "x": 311.4703271665348,
      "y": 212.41616880620637
  },
  {
      "x": 311.4703271665348,
      "y": 212.41616880620637
  },
  {
      "x": 312.5709290293141,
      "y": 212.41616880620637
  },
  {
      "x": 312.5709290293141,
      "y": 214.61737262803234
  },
  {
      "x": 312.5709290293141,
      "y": 215.71797453894533
  },
  {
      "x": 312.5709290293141,
      "y": 216.8185764498583
  },
  {
      "x": 312.5709290293141,
      "y": 216.8185764498583
  },
  {
      "x": 312.5709290293141,
      "y": 217.9191783607713
  },
  {
      "x": 312.5709290293141,
      "y": 219.01978027168428
  },
  {
      "x": 312.5709290293141,
      "y": 220.12038218259727
  },
  {
      "x": 312.5709290293141,
      "y": 221.22098409351025
  },
  {
      "x": 313.67153089209336,
      "y": 221.22098409351025
  }
]

export const botRopePath =[
  {
      "x": 829.8538045355732,
      "y": 599.8280414475776
  },
  {
      "x": 828.7532026727939,
      "y": 599.8280414475776
  },
  {
      "x": 827.6526008100147,
      "y": 599.8280414475776
  },
  {
      "x": 827.6526008100147,
      "y": 599.8280414475776
  },
  {
      "x": 826.5519989472355,
      "y": 600.9286433584905
  },
  {
      "x": 824.3507952216769,
      "y": 603.1298471803165
  },
  {
      "x": 823.2501933588976,
      "y": 604.2304490912295
  },
  {
      "x": 822.1495914961183,
      "y": 604.2304490912295
  },
  {
      "x": 819.9483877705597,
      "y": 604.2304490912295
  },
  {
      "x": 818.8477859077805,
      "y": 605.3310510021424
  },
  {
      "x": 817.7471840450012,
      "y": 607.5322548239684
  },
  {
      "x": 814.4453784566634,
      "y": 608.6328567348814
  },
  {
      "x": 813.3447765938841,
      "y": 609.7334586457944
  },
  {
      "x": 810.0429710055463,
      "y": 611.9346624676203
  },
  {
      "x": 807.8417672799877,
      "y": 613.0352643785334
  },
  {
      "x": 805.6405635544291,
      "y": 615.2364682003594
  },
  {
      "x": 804.5399616916499,
      "y": 616.3370701112723
  },
  {
      "x": 802.3387579660914,
      "y": 617.4376720221853
  },
  {
      "x": 800.1375542405328,
      "y": 619.6388758440113
  },
  {
      "x": 797.9363505149743,
      "y": 619.6388758440113
  },
  {
      "x": 796.835748652195,
      "y": 621.8400796658373
  },
  {
      "x": 794.6345449266364,
      "y": 622.9406815767503
  },
  {
      "x": 792.4333412010778,
      "y": 625.1418853985763
  },
  {
      "x": 790.2321374755194,
      "y": 626.2424873094892
  },
  {
      "x": 788.0309337499608,
      "y": 627.3430892204022
  },
  {
      "x": 785.8297300244022,
      "y": 629.5442930422282
  },
  {
      "x": 784.729128161623,
      "y": 629.5442930422282
  },
  {
      "x": 782.5279244360644,
      "y": 630.6448949531411
  },
  {
      "x": 781.4273225732851,
      "y": 630.6448949531411
  },
  {
      "x": 780.3267207105059,
      "y": 632.8460987749671
  },
  {
      "x": 779.2261188477266,
      "y": 633.9467006858802
  },
  {
      "x": 778.1255169849474,
      "y": 633.9467006858802
  },
  {
      "x": 774.8237113966095,
      "y": 636.1479045077061
  },
  {
      "x": 770.4213039454924,
      "y": 638.3491083295321
  },
  {
      "x": 766.0188964943753,
      "y": 639.449710240445
  },
  {
      "x": 762.7170909060375,
      "y": 641.650914062271
  },
  {
      "x": 761.6164890432582,
      "y": 641.650914062271
  },
  {
      "x": 759.4152853176996,
      "y": 642.751515973184
  },
  {
      "x": 756.1134797293619,
      "y": 642.751515973184
  },
  {
      "x": 752.811674141024,
      "y": 643.852117884097
  },
  {
      "x": 751.7110722782447,
      "y": 643.852117884097
  },
  {
      "x": 748.4092666899069,
      "y": 643.852117884097
  },
  {
      "x": 746.2080629643483,
      "y": 643.852117884097
  },
  {
      "x": 742.9062573760106,
      "y": 644.95271979501
  },
  {
      "x": 739.6044517876727,
      "y": 646.0533217059229
  },
  {
      "x": 737.4032480621141,
      "y": 646.0533217059229
  },
  {
      "x": 735.2020443365556,
      "y": 646.0533217059229
  },
  {
      "x": 731.9002387482178,
      "y": 648.2545255277489
  },
  {
      "x": 729.6990350226592,
      "y": 648.2545255277489
  },
  {
      "x": 726.3972294343214,
      "y": 648.2545255277489
  },
  {
      "x": 723.0954238459835,
      "y": 649.355127438662
  },
  {
      "x": 719.7936182576458,
      "y": 649.355127438662
  },
  {
      "x": 717.5924145320872,
      "y": 650.4557293495749
  },
  {
      "x": 716.4918126693079,
      "y": 651.5563312604879
  },
  {
      "x": 713.1900070809701,
      "y": 651.5563312604879
  },
  {
      "x": 709.8882014926323,
      "y": 651.5563312604879
  },
  {
      "x": 708.787599629853,
      "y": 651.5563312604879
  },
  {
      "x": 706.5863959042945,
      "y": 651.5563312604879
  },
  {
      "x": 704.3851921787359,
      "y": 651.5563312604879
  },
  {
      "x": 703.2845903159566,
      "y": 651.5563312604879
  },
  {
      "x": 699.9827847276188,
      "y": 652.6569331714009
  },
  {
      "x": 696.680979139281,
      "y": 652.6569331714009
  },
  {
      "x": 695.5803772765017,
      "y": 652.6569331714009
  },
  {
      "x": 691.1779698253846,
      "y": 653.7575350823139
  },
  {
      "x": 690.0773679626053,
      "y": 653.7575350823139
  },
  {
      "x": 686.7755623742676,
      "y": 653.7575350823139
  },
  {
      "x": 684.574358648709,
      "y": 653.7575350823139
  },
  {
      "x": 682.3731549231504,
      "y": 654.8581369932268
  },
  {
      "x": 680.1719511975919,
      "y": 654.8581369932268
  },
  {
      "x": 677.9707474720333,
      "y": 655.9587389041399
  },
  {
      "x": 674.6689418836955,
      "y": 657.0593408150528
  },
  {
      "x": 671.3671362953577,
      "y": 657.0593408150528
  },
  {
      "x": 668.0653307070198,
      "y": 657.0593408150528
  },
  {
      "x": 664.763525118682,
      "y": 657.0593408150528
  },
  {
      "x": 651.5563027653307,
      "y": 658.1599427259658
  },
  {
      "x": 642.7514878630965,
      "y": 658.1599427259658
  },
  {
      "x": 632.846071098083,
      "y": 658.1599427259658
  },
  {
      "x": 628.4436636469659,
      "y": 658.1599427259658
  },
  {
      "x": 625.1418580586281,
      "y": 658.1599427259658
  },
  {
      "x": 621.8400524702903,
      "y": 658.1599427259658
  },
  {
      "x": 619.6388487447317,
      "y": 658.1599427259658
  },
  {
      "x": 616.337043156394,
      "y": 658.1599427259658
  },
  {
      "x": 613.0352375680561,
      "y": 658.1599427259658
  },
  {
      "x": 611.9346357052768,
      "y": 658.1599427259658
  },
  {
      "x": 608.632830116939,
      "y": 658.1599427259658
  },
  {
      "x": 606.4316263913804,
      "y": 658.1599427259658
  },
  {
      "x": 603.1298208030427,
      "y": 658.1599427259658
  },
  {
      "x": 599.8280152147048,
      "y": 659.2605446368788
  },
  {
      "x": 594.3250059008084,
      "y": 660.3611465477918
  },
  {
      "x": 587.7213947241328,
      "y": 660.3611465477918
  },
  {
      "x": 581.1177835474571,
      "y": 660.3611465477918
  },
  {
      "x": 574.5141723707815,
      "y": 660.3611465477918
  },
  {
      "x": 566.8099593313266,
      "y": 660.3611465477918
  },
  {
      "x": 559.1057462918716,
      "y": 660.3611465477918
  },
  {
      "x": 552.502135115196,
      "y": 660.3611465477918
  },
  {
      "x": 541.4961164874032,
      "y": 660.3611465477918
  },
  {
      "x": 532.6913015851691,
      "y": 660.3611465477918
  },
  {
      "x": 527.1882922712726,
      "y": 660.3611465477918
  },
  {
      "x": 520.584681094597,
      "y": 660.3611465477918
  },
  {
      "x": 515.0816717807006,
      "y": 660.3611465477918
  },
  {
      "x": 510.67926432958353,
      "y": 660.3611465477918
  },
  {
      "x": 499.6732457017908,
      "y": 660.3611465477918
  },
  {
      "x": 497.4720419762322,
      "y": 660.3611465477918
  },
  {
      "x": 493.06963452511513,
      "y": 660.3611465477918
  },
  {
      "x": 488.66722707399805,
      "y": 660.3611465477918
  },
  {
      "x": 484.26481962288096,
      "y": 660.3611465477918
  },
  {
      "x": 480.9630140345431,
      "y": 660.3611465477918
  },
  {
      "x": 477.6612084462053,
      "y": 660.3611465477918
  },
  {
      "x": 475.46000472064674,
      "y": 660.3611465477918
  },
  {
      "x": 473.25880099508817,
      "y": 660.3611465477918
  },
  {
      "x": 469.95699540675037,
      "y": 660.3611465477918
  },
  {
      "x": 468.8563935439711,
      "y": 660.3611465477918
  },
  {
      "x": 465.5545879556333,
      "y": 660.3611465477918
  },
  {
      "x": 462.2527823672954,
      "y": 660.3611465477918
  },
  {
      "x": 462.2527823672954,
      "y": 660.3611465477918
  },
  {
      "x": 458.9509767789576,
      "y": 660.3611465477918
  },
  {
      "x": 457.85037491617834,
      "y": 660.3611465477918
  },
  {
      "x": 456.74977305339905,
      "y": 660.3611465477918
  },
  {
      "x": 455.64917119061977,
      "y": 660.3611465477918
  },
  {
      "x": 453.44796746506125,
      "y": 660.3611465477918
  },
  {
      "x": 450.1461618767234,
      "y": 660.3611465477918
  },
  {
      "x": 446.8443562883856,
      "y": 660.3611465477918
  },
  {
      "x": 441.3413469744892,
      "y": 660.3611465477918
  },
  {
      "x": 438.03954138615137,
      "y": 660.3611465477918
  },
  {
      "x": 435.83833766059286,
      "y": 660.3611465477918
  },
  {
      "x": 433.6371339350343,
      "y": 660.3611465477918
  },
  {
      "x": 431.4359302094757,
      "y": 660.3611465477918
  },
  {
      "x": 428.1341246211379,
      "y": 660.3611465477918
  },
  {
      "x": 427.03352275835863,
      "y": 660.3611465477918
  },
  {
      "x": 425.93292089557934,
      "y": 660.3611465477918
  },
  {
      "x": 424.8323190328001,
      "y": 660.3611465477918
  },
  {
      "x": 422.63111530724154,
      "y": 660.3611465477918
  },
  {
      "x": 422.63111530724154,
      "y": 660.3611465477918
  },
  {
      "x": 421.53051344446226,
      "y": 660.3611465477918
  },
  {
      "x": 418.22870785612446,
      "y": 660.3611465477918
  },
  {
      "x": 417.1281059933452,
      "y": 659.2605446368788
  },
  {
      "x": 416.0275041305659,
      "y": 659.2605446368788
  },
  {
      "x": 413.8263004050074,
      "y": 658.1599427259658
  },
  {
      "x": 413.8263004050074,
      "y": 658.1599427259658
  },
  {
      "x": 410.5244948166695,
      "y": 657.0593408150528
  },
  {
      "x": 407.2226892283317,
      "y": 657.0593408150528
  },
  {
      "x": 403.92088363999386,
      "y": 655.9587389041399
  },
  {
      "x": 399.5184761888768,
      "y": 654.8581369932268
  },
  {
      "x": 397.3172724633182,
      "y": 653.7575350823139
  },
  {
      "x": 395.1160687377597,
      "y": 653.7575350823139
  },
  {
      "x": 392.9148650122011,
      "y": 652.6569331714009
  },
  {
      "x": 390.71366128664255,
      "y": 652.6569331714009
  },
  {
      "x": 387.41185569830475,
      "y": 652.6569331714009
  },
  {
      "x": 384.11005010996695,
      "y": 652.6569331714009
  },
  {
      "x": 383.00944824718766,
      "y": 652.6569331714009
  },
  {
      "x": 380.8082445216291,
      "y": 652.6569331714009
  },
  {
      "x": 379.7076426588498,
      "y": 652.6569331714009
  },
  {
      "x": 378.6070407960706,
      "y": 652.6569331714009
  },
  {
      "x": 377.5064389332913,
      "y": 652.6569331714009
  },
  {
      "x": 375.3052352077327,
      "y": 652.6569331714009
  },
  {
      "x": 374.20463334495344,
      "y": 652.6569331714009
  },
  {
      "x": 374.20463334495344,
      "y": 652.6569331714009
  },
  {
      "x": 369.80222589383635,
      "y": 652.6569331714009
  },
  {
      "x": 367.6010221682778,
      "y": 652.6569331714009
  },
  {
      "x": 360.9974109916021,
      "y": 652.6569331714009
  },
  {
      "x": 357.6956054032643,
      "y": 652.6569331714009
  },
  {
      "x": 356.59500354048504,
      "y": 652.6569331714009
  },
  {
      "x": 355.49440167770575,
      "y": 652.6569331714009
  },
  {
      "x": 354.3937998149265,
      "y": 652.6569331714009
  },
  {
      "x": 353.29319795214724,
      "y": 652.6569331714009
  },
  {
      "x": 352.19259608936795,
      "y": 652.6569331714009
  },
  {
      "x": 352.19259608936795,
      "y": 653.7575350823139
  },
  {
      "x": 352.19259608936795,
      "y": 653.7575350823139
  },
  {
      "x": 351.09199422658867,
      "y": 654.8581369932268
  },
  {
      "x": 349.9913923638094,
      "y": 654.8581369932268
  },
  {
      "x": 347.79018863825087,
      "y": 655.9587389041399
  },
  {
      "x": 347.79018863825087,
      "y": 655.9587389041399
  },
  {
      "x": 346.6895867754716,
      "y": 657.0593408150528
  },
  {
      "x": 344.488383049913,
      "y": 657.0593408150528
  },
  {
      "x": 343.3877811871338,
      "y": 657.0593408150528
  },
  {
      "x": 343.3877811871338,
      "y": 658.1599427259658
  },
  {
      "x": 341.1865774615752,
      "y": 658.1599427259658
  },
  {
      "x": 338.98537373601664,
      "y": 659.2605446368788
  },
  {
      "x": 338.98537373601664,
      "y": 660.3611465477918
  },
  {
      "x": 336.7841700104581,
      "y": 661.4617484587047
  },
  {
      "x": 334.58296628489956,
      "y": 661.4617484587047
  },
  {
      "x": 333.48236442212027,
      "y": 662.5623503696178
  },
  {
      "x": 332.381762559341,
      "y": 663.6629522805307
  },
  {
      "x": 331.28116069656176,
      "y": 664.7635541914437
  },
  {
      "x": 330.18055883378247,
      "y": 664.7635541914437
  },
  {
      "x": 327.9793551082239,
      "y": 664.7635541914437
  },
  {
      "x": 326.8787532454446,
      "y": 664.7635541914437
  },
  {
      "x": 326.8787532454446,
      "y": 665.8641561023567
  },
  {
      "x": 326.8787532454446,
      "y": 665.8641561023567
  },
  {
      "x": 325.7781513826653,
      "y": 668.0653599241826
  },
  {
      "x": 323.5769476571068,
      "y": 670.2665637460086
  },
  {
      "x": 323.5769476571068,
      "y": 670.2665637460086
  },
  {
      "x": 323.5769476571068,
      "y": 671.3671656569217
  },
  {
      "x": 322.47634579432753,
      "y": 673.5683694787476
  },
  {
      "x": 321.37574393154824,
      "y": 673.5683694787476
  },
  {
      "x": 321.37574393154824,
      "y": 674.6689713896606
  },
  {
      "x": 321.37574393154824,
      "y": 674.6689713896606
  },
  {
      "x": 321.37574393154824,
      "y": 675.7695733005736
  },
  {
      "x": 321.37574393154824,
      "y": 676.8701752114866
  },
  {
      "x": 321.37574393154824,
      "y": 677.9707771223996
  },
  {
      "x": 322.47634579432753,
      "y": 679.0713790333126
  },
  {
      "x": 323.5769476571068,
      "y": 679.0713790333126
  },
  {
      "x": 323.5769476571068,
      "y": 680.1719809442255
  },
  {
      "x": 323.5769476571068,
      "y": 681.2725828551386
  },
  {
      "x": 323.5769476571068,
      "y": 683.4737866769646
  },
  {
      "x": 325.7781513826653,
      "y": 683.4737866769646
  },
  {
      "x": 325.7781513826653,
      "y": 683.4737866769646
  },
  {
      "x": 325.7781513826653,
      "y": 684.5743885878775
  },
  {
      "x": 326.8787532454446,
      "y": 686.7755924097034
  },
  {
      "x": 329.0799569710032,
      "y": 686.7755924097034
  },
  {
      "x": 330.18055883378247,
      "y": 687.8761943206165
  },
  {
      "x": 331.28116069656176,
      "y": 687.8761943206165
  },
  {
      "x": 333.48236442212027,
      "y": 687.8761943206165
  },
  {
      "x": 334.58296628489956,
      "y": 687.8761943206165
  },
  {
      "x": 334.58296628489956,
      "y": 688.9767962315294
  },
  {
      "x": 336.7841700104581,
      "y": 688.9767962315294
  },
  {
      "x": 337.88477187323736,
      "y": 688.9767962315294
  },
  {
      "x": 340.0859755987959,
      "y": 688.9767962315294
  },
  {
      "x": 343.3877811871338,
      "y": 688.9767962315294
  },
  {
      "x": 345.5889849126923,
      "y": 688.9767962315294
  },
  {
      "x": 347.79018863825087,
      "y": 688.9767962315294
  },
  {
      "x": 351.09199422658867,
      "y": 688.9767962315294
  },
  {
      "x": 352.19259608936795,
      "y": 688.9767962315294
  },
  {
      "x": 354.3937998149265,
      "y": 688.9767962315294
  },
  {
      "x": 356.59500354048504,
      "y": 688.9767962315294
  },
  {
      "x": 356.59500354048504,
      "y": 688.9767962315294
  },
  {
      "x": 360.9974109916021,
      "y": 688.9767962315294
  },
  {
      "x": 363.1986147171607,
      "y": 688.9767962315294
  },
  {
      "x": 365.39981844271927,
      "y": 687.8761943206165
  },
  {
      "x": 369.80222589383635,
      "y": 687.8761943206165
  },
  {
      "x": 370.90282775661564,
      "y": 687.8761943206165
  },
  {
      "x": 373.10403148217415,
      "y": 687.8761943206165
  },
  {
      "x": 374.20463334495344,
      "y": 687.8761943206165
  },
  {
      "x": 375.3052352077327,
      "y": 687.8761943206165
  },
  {
      "x": 376.405837070512,
      "y": 687.8761943206165
  },
  {
      "x": 378.6070407960706,
      "y": 687.8761943206165
  },
  {
      "x": 379.7076426588498,
      "y": 687.8761943206165
  },
  {
      "x": 380.8082445216291,
      "y": 687.8761943206165
  },
  {
      "x": 383.00944824718766,
      "y": 687.8761943206165
  },
  {
      "x": 387.41185569830475,
      "y": 687.8761943206165
  },
  {
      "x": 394.0154668749804,
      "y": 687.8761943206165
  },
  {
      "x": 397.3172724633182,
      "y": 686.7755924097034
  },
  {
      "x": 400.61907805165606,
      "y": 685.6749904987905
  },
  {
      "x": 401.71967991443535,
      "y": 685.6749904987905
  },
  {
      "x": 405.02148550277315,
      "y": 684.5743885878775
  },
  {
      "x": 408.32329109111095,
      "y": 684.5743885878775
  },
  {
      "x": 410.5244948166695,
      "y": 683.4737866769646
  },
  {
      "x": 418.22870785612446,
      "y": 681.2725828551386
  },
  {
      "x": 422.63111530724154,
      "y": 680.1719809442255
  },
  {
      "x": 424.8323190328001,
      "y": 679.0713790333126
  },
  {
      "x": 427.03352275835863,
      "y": 677.9707771223996
  },
  {
      "x": 429.2347264839172,
      "y": 677.9707771223996
  },
  {
      "x": 431.4359302094757,
      "y": 676.8701752114866
  },
  {
      "x": 432.536532072255,
      "y": 676.8701752114866
  },
  {
      "x": 434.73773579781357,
      "y": 675.7695733005736
  },
  {
      "x": 438.03954138615137,
      "y": 674.6689713896606
  },
  {
      "x": 440.24074511170994,
      "y": 674.6689713896606
  },
  {
      "x": 442.4419488372685,
      "y": 674.6689713896606
  },
  {
      "x": 444.643152562827,
      "y": 673.5683694787476
  },
  {
      "x": 449.04556001394417,
      "y": 672.4677675678346
  },
  {
      "x": 449.04556001394417,
      "y": 672.4677675678346
  },
  {
      "x": 452.34736560228197,
      "y": 671.3671656569217
  },
  {
      "x": 454.54856932784054,
      "y": 670.2665637460086
  },
  {
      "x": 457.85037491617834,
      "y": 669.1659618350957
  },
  {
      "x": 460.0515786417369,
      "y": 668.0653599241826
  },
  {
      "x": 461.15218050451614,
      "y": 668.0653599241826
  },
  {
      "x": 462.2527823672954,
      "y": 668.0653599241826
  },
  {
      "x": 462.2527823672954,
      "y": 666.9647580132697
  },
  {
      "x": 464.453986092854,
      "y": 665.8641561023567
  },
  {
      "x": 467.7557916811918,
      "y": 665.8641561023567
  },
  {
      "x": 472.15819913230894,
      "y": 662.5623503696178
  },
  {
      "x": 476.560606583426,
      "y": 661.4617484587047
  },
  {
      "x": 478.76181030898454,
      "y": 659.2605446368788
  },
  {
      "x": 479.8624121717638,
      "y": 658.1599427259658
  },
  {
      "x": 483.1642177601017,
      "y": 657.0593408150528
  },
  {
      "x": 485.3654214856602,
      "y": 657.0593408150528
  },
  {
      "x": 488.66722707399805,
      "y": 654.8581369932268
  },
  {
      "x": 489.76782893677733,
      "y": 653.7575350823139
  },
  {
      "x": 493.06963452511513,
      "y": 652.6569331714009
  },
  {
      "x": 495.2708382506737,
      "y": 650.4557293495749
  },
  {
      "x": 497.4720419762322,
      "y": 649.355127438662
  },
  {
      "x": 500.7738475645701,
      "y": 648.2545255277489
  },
  {
      "x": 501.8744494273493,
      "y": 647.153923616836
  },
  {
      "x": 502.9750512901286,
      "y": 647.153923616836
  },
  {
      "x": 506.27685687846645,
      "y": 644.95271979501
  },
  {
      "x": 509.57866246680425,
      "y": 643.852117884097
  },
  {
      "x": 511.7798661923628,
      "y": 642.751515973184
  },
  {
      "x": 513.9810699179213,
      "y": 641.650914062271
  },
  {
      "x": 515.0816717807006,
      "y": 639.449710240445
  },
  {
      "x": 519.4840792318178,
      "y": 638.3491083295321
  },
  {
      "x": 521.6852829573763,
      "y": 637.2485064186191
  },
  {
      "x": 523.8864866829348,
      "y": 635.0473025967931
  },
  {
      "x": 524.9870885457141,
      "y": 635.0473025967931
  },
  {
      "x": 528.2888941340519,
      "y": 631.7454968640542
  },
  {
      "x": 532.6913015851691,
      "y": 629.5442930422282
  },
  {
      "x": 534.8925053107275,
      "y": 628.4436911313152
  },
  {
      "x": 537.0937090362861,
      "y": 626.2424873094892
  },
  {
      "x": 538.1943108990654,
      "y": 625.1418853985763
  },
  {
      "x": 540.395514624624,
      "y": 624.0412834876632
  },
  {
      "x": 542.5967183501825,
      "y": 621.8400796658373
  },
  {
      "x": 545.8985239385204,
      "y": 621.8400796658373
  },
  {
      "x": 545.8985239385204,
      "y": 620.7394777549243
  },
  {
      "x": 548.0997276640788,
      "y": 618.5382739330983
  },
  {
      "x": 550.3009313896374,
      "y": 617.4376720221853
  },
  {
      "x": 552.502135115196,
      "y": 616.3370701112723
  },
  {
      "x": 553.6027369779753,
      "y": 615.2364682003594
  },
  {
      "x": 554.7033388407546,
      "y": 614.1358662894463
  },
  {
      "x": 556.9045425663131,
      "y": 613.0352643785334
  },
  {
      "x": 559.1057462918716,
      "y": 611.9346624676203
  },
  {
      "x": 560.2063481546509,
      "y": 609.7334586457944
  },
  {
      "x": 561.3069500174302,
      "y": 608.6328567348814
  },
  {
      "x": 563.5081537429887,
      "y": 608.6328567348814
  },
  {
      "x": 564.608755605768,
      "y": 607.5322548239684
  },
  {
      "x": 569.0111630568852,
      "y": 603.1298471803165
  },
  {
      "x": 572.3129686452229,
      "y": 600.9286433584905
  },
  {
      "x": 573.4135705080022,
      "y": 599.8280414475776
  },
  {
      "x": 575.6147742335608,
      "y": 598.7274395366645
  },
  {
      "x": 576.71537609634,
      "y": 596.5262357148385
  },
  {
      "x": 578.9165798218986,
      "y": 595.4256338039256
  },
  {
      "x": 581.1177835474571,
      "y": 594.3250318930126
  },
  {
      "x": 582.2183854102364,
      "y": 591.0232261602737
  },
  {
      "x": 583.3189872730156,
      "y": 591.0232261602737
  },
  {
      "x": 585.5201909985742,
      "y": 589.9226242493606
  },
  {
      "x": 587.7213947241328,
      "y": 587.7214204275347
  },
  {
      "x": 589.9225984496913,
      "y": 586.6208185166217
  },
  {
      "x": 591.0232003124706,
      "y": 584.4196146947958
  },
  {
      "x": 593.2244040380291,
      "y": 582.2184108729698
  },
  {
      "x": 594.3250059008084,
      "y": 582.2184108729698
  },
  {
      "x": 597.6268114891462,
      "y": 581.1178089620568
  },
  {
      "x": 599.8280152147048,
      "y": 577.8160032293179
  },
  {
      "x": 600.9286170774841,
      "y": 576.7154013184048
  },
  {
      "x": 603.1298208030427,
      "y": 574.5141974965788
  },
  {
      "x": 604.230422665822,
      "y": 573.4135955856659
  },
  {
      "x": 607.5322282541597,
      "y": 571.21239176384
  },
  {
      "x": 609.7334319797183,
      "y": 569.011187942014
  },
  {
      "x": 611.9346357052768,
      "y": 567.9105860311009
  },
  {
      "x": 613.0352375680561,
      "y": 565.709382209275
  },
  {
      "x": 616.337043156394,
      "y": 563.508178387449
  },
  {
      "x": 620.739450607511,
      "y": 560.20637265471
  },
  {
      "x": 624.0412561958489,
      "y": 556.9045669219711
  },
  {
      "x": 625.1418580586281,
      "y": 555.803965011058
  },
  {
      "x": 627.3430617841867,
      "y": 553.6027611892321
  },
  {
      "x": 628.4436636469659,
      "y": 552.5021592783191
  },
  {
      "x": 629.5442655097452,
      "y": 551.4015573674061
  },
  {
      "x": 632.846071098083,
      "y": 550.3009554564932
  },
  {
      "x": 635.0472748236416,
      "y": 548.0997516346672
  },
  {
      "x": 637.2484785492002,
      "y": 546.9991497237542
  },
  {
      "x": 638.3490804119795,
      "y": 546.9991497237542
  },
  {
      "x": 641.6508860003172,
      "y": 544.7979459019282
  },
  {
      "x": 642.7514878630965,
      "y": 542.5967420801022
  },
  {
      "x": 644.9526915886551,
      "y": 542.5967420801022
  },
  {
      "x": 647.1538953142136,
      "y": 541.4961401691893
  },
  {
      "x": 648.2544971769929,
      "y": 540.3955382582762
  },
  {
      "x": 650.4557009025515,
      "y": 538.1943344364503
  },
  {
      "x": 652.6569046281099,
      "y": 538.1943344364503
  },
  {
      "x": 655.9587102164478,
      "y": 535.9931306146243
  },
  {
      "x": 657.0593120792271,
      "y": 533.7919267927983
  },
  {
      "x": 660.3611176675649,
      "y": 533.7919267927983
  },
  {
      "x": 664.763525118682,
      "y": 531.5907229709724
  },
  {
      "x": 669.1659325697991,
      "y": 529.3895191491464
  },
  {
      "x": 673.5683400209163,
      "y": 527.1883153273204
  },
  {
      "x": 676.870145609254,
      "y": 524.9871115054945
  },
  {
      "x": 677.9707474720333,
      "y": 523.8865095945815
  },
  {
      "x": 681.2725530603711,
      "y": 523.8865095945815
  },
  {
      "x": 682.3731549231504,
      "y": 522.7859076836685
  },
  {
      "x": 684.574358648709,
      "y": 521.6853057727556
  },
  {
      "x": 686.7755623742676,
      "y": 520.5847038618425
  },
  {
      "x": 687.8761642370467,
      "y": 520.5847038618425
  },
  {
      "x": 690.0773679626053,
      "y": 519.4841019509296
  },
  {
      "x": 692.2785716881639,
      "y": 518.3835000400165
  },
  {
      "x": 694.4797754137225,
      "y": 518.3835000400165
  },
  {
      "x": 695.5803772765017,
      "y": 517.2828981291036
  },
  {
      "x": 696.680979139281,
      "y": 517.2828981291036
  },
  {
      "x": 699.9827847276188,
      "y": 517.2828981291036
  },
  {
      "x": 699.9827847276188,
      "y": 516.1822962181906
  },
  {
      "x": 701.083386590398,
      "y": 516.1822962181906
  },
  {
      "x": 703.2845903159566,
      "y": 516.1822962181906
  },
  {
      "x": 704.3851921787359,
      "y": 515.0816943072776
  },
  {
      "x": 704.3851921787359,
      "y": 515.0816943072776
  },
  {
      "x": 705.4857940415152,
      "y": 515.0816943072776
  },
  {
      "x": 707.6869977670738,
      "y": 515.0816943072776
  },
  {
      "x": 708.787599629853,
      "y": 515.0816943072776
  },
  {
      "x": 710.9888033554115,
      "y": 515.0816943072776
  },
  {
      "x": 713.1900070809701,
      "y": 515.0816943072776
  },
  {
      "x": 714.2906089437494,
      "y": 513.9810923963646
  },
  {
      "x": 716.4918126693079,
      "y": 513.9810923963646
  },
  {
      "x": 717.5924145320872,
      "y": 513.9810923963646
  },
  {
      "x": 718.6930163948665,
      "y": 512.8804904854517
  },
  {
      "x": 720.8942201204251,
      "y": 512.8804904854517
  },
  {
      "x": 721.9948219832042,
      "y": 512.8804904854517
  },
  {
      "x": 723.0954238459835,
      "y": 512.8804904854517
  },
  {
      "x": 725.2966275715421,
      "y": 512.8804904854517
  },
  {
      "x": 726.3972294343214,
      "y": 512.8804904854517
  },
  {
      "x": 727.4978312971007,
      "y": 512.8804904854517
  },
  {
      "x": 728.59843315988,
      "y": 512.8804904854517
  },
  {
      "x": 729.6990350226592,
      "y": 512.8804904854517
  },
  {
      "x": 730.7996368854385,
      "y": 512.8804904854517
  },
  {
      "x": 733.0008406109971,
      "y": 513.9810923963646
  },
  {
      "x": 735.2020443365556,
      "y": 513.9810923963646
  },
  {
      "x": 736.3026461993348,
      "y": 513.9810923963646
  },
  {
      "x": 738.5038499248934,
      "y": 513.9810923963646
  },
  {
      "x": 739.6044517876727,
      "y": 513.9810923963646
  },
  {
      "x": 742.9062573760106,
      "y": 513.9810923963646
  },
  {
      "x": 745.1074611015691,
      "y": 513.9810923963646
  },
  {
      "x": 747.3086648271276,
      "y": 513.9810923963646
  },
  {
      "x": 748.4092666899069,
      "y": 513.9810923963646
  },
  {
      "x": 751.7110722782447,
      "y": 515.0816943072776
  },
  {
      "x": 752.811674141024,
      "y": 515.0816943072776
  },
  {
      "x": 753.9122760038033,
      "y": 515.0816943072776
  },
  {
      "x": 755.0128778665826,
      "y": 515.0816943072776
  },
  {
      "x": 757.2140815921412,
      "y": 516.1822962181906
  },
  {
      "x": 757.2140815921412,
      "y": 516.1822962181906
  },
  {
      "x": 758.3146834549203,
      "y": 516.1822962181906
  },
  {
      "x": 759.4152853176996,
      "y": 516.1822962181906
  },
  {
      "x": 761.6164890432582,
      "y": 516.1822962181906
  },
  {
      "x": 761.6164890432582,
      "y": 517.2828981291036
  },
  {
      "x": 763.8176927688168,
      "y": 517.2828981291036
  },
  {
      "x": 764.918294631596,
      "y": 517.2828981291036
  },
  {
      "x": 766.0188964943753,
      "y": 517.2828981291036
  },
  {
      "x": 768.2201002199339,
      "y": 518.3835000400165
  },
  {
      "x": 769.3207020827131,
      "y": 518.3835000400165
  },
  {
      "x": 770.4213039454924,
      "y": 518.3835000400165
  },
  {
      "x": 771.5219058082716,
      "y": 520.5847038618425
  },
  {
      "x": 773.7231095338302,
      "y": 520.5847038618425
  },
  {
      "x": 773.7231095338302,
      "y": 521.6853057727556
  },
  {
      "x": 774.8237113966095,
      "y": 522.7859076836685
  },
  {
      "x": 774.8237113966095,
      "y": 522.7859076836685
  },
  {
      "x": 775.9243132593888,
      "y": 522.7859076836685
  },
  {
      "x": 777.0249151221681,
      "y": 524.9871115054945
  },
  {
      "x": 778.1255169849474,
      "y": 524.9871115054945
  },
  {
      "x": 778.1255169849474,
      "y": 526.0877134164075
  },
  {
      "x": 779.2261188477266,
      "y": 527.1883153273204
  },
  {
      "x": 779.2261188477266,
      "y": 529.3895191491464
  },
  {
      "x": 779.2261188477266,
      "y": 529.3895191491464
  },
  {
      "x": 779.2261188477266,
      "y": 530.4901210600594
  },
  {
      "x": 780.3267207105059,
      "y": 532.6913248818854
  },
  {
      "x": 780.3267207105059,
      "y": 533.7919267927983
  },
  {
      "x": 780.3267207105059,
      "y": 534.8925287037114
  },
  {
      "x": 780.3267207105059,
      "y": 537.0937325255373
  },
  {
      "x": 780.3267207105059,
      "y": 538.1943344364503
  },
  {
      "x": 780.3267207105059,
      "y": 541.4961401691893
  },
  {
      "x": 780.3267207105059,
      "y": 542.5967420801022
  },
  {
      "x": 780.3267207105059,
      "y": 545.8985478128412
  },
  {
      "x": 779.2261188477266,
      "y": 546.9991497237542
  },
  {
      "x": 779.2261188477266,
      "y": 550.3009554564932
  },
  {
      "x": 778.1255169849474,
      "y": 551.4015573674061
  },
  {
      "x": 778.1255169849474,
      "y": 552.5021592783191
  },
  {
      "x": 778.1255169849474,
      "y": 554.7033631001451
  },
  {
      "x": 775.9243132593888,
      "y": 556.9045669219711
  },
  {
      "x": 774.8237113966095,
      "y": 559.105770743797
  },
  {
      "x": 774.8237113966095,
      "y": 560.20637265471
  },
  {
      "x": 774.8237113966095,
      "y": 560.20637265471
  },
  {
      "x": 773.7231095338302,
      "y": 561.306974565623
  },
  {
      "x": 772.6225076710509,
      "y": 562.407576476536
  },
  {
      "x": 771.5219058082716,
      "y": 563.508178387449
  },
  {
      "x": 770.4213039454924,
      "y": 564.608780298362
  },
  {
      "x": 769.3207020827131,
      "y": 565.709382209275
  },
  {
      "x": 768.2201002199339,
      "y": 566.809984120188
  },
  {
      "x": 768.2201002199339,
      "y": 567.9105860311009
  },
  {
      "x": 767.1194983571546,
      "y": 567.9105860311009
  },
  {
      "x": 766.0188964943753,
      "y": 567.9105860311009
  },
  {
      "x": 761.6164890432582,
      "y": 571.21239176384
  },
  {
      "x": 757.2140815921412,
      "y": 573.4135955856659
  },
  {
      "x": 755.0128778665826,
      "y": 573.4135955856659
  },
  {
      "x": 753.9122760038033,
      "y": 574.5141974965788
  },
  {
      "x": 752.811674141024,
      "y": 575.6147994074919
  },
  {
      "x": 751.7110722782447,
      "y": 577.8160032293179
  },
  {
      "x": 750.6104704154654,
      "y": 577.8160032293179
  },
  {
      "x": 749.5098685526862,
      "y": 577.8160032293179
  },
  {
      "x": 748.4092666899069,
      "y": 577.8160032293179
  },
  {
      "x": 745.1074611015691,
      "y": 578.9166051402308
  },
  {
      "x": 744.0068592387898,
      "y": 578.9166051402308
  },
  {
      "x": 742.9062573760106,
      "y": 580.0172070511438
  },
  {
      "x": 739.6044517876727,
      "y": 581.1178089620568
  },
  {
      "x": 739.6044517876727,
      "y": 582.2184108729698
  },
  {
      "x": 738.5038499248934,
      "y": 582.2184108729698
  },
  {
      "x": 737.4032480621141,
      "y": 582.2184108729698
  },
  {
      "x": 736.3026461993348,
      "y": 582.2184108729698
  },
  {
      "x": 735.2020443365556,
      "y": 582.2184108729698
  },
  {
      "x": 733.0008406109971,
      "y": 582.2184108729698
  },
  {
      "x": 730.7996368854385,
      "y": 583.3190127838827
  },
  {
      "x": 726.3972294343214,
      "y": 584.4196146947958
  },
  {
      "x": 724.1960257087628,
      "y": 586.6208185166217
  },
  {
      "x": 721.9948219832042,
      "y": 586.6208185166217
  },
  {
      "x": 718.6930163948665,
      "y": 586.6208185166217
  },
  {
      "x": 717.5924145320872,
      "y": 586.6208185166217
  },
  {
      "x": 716.4918126693079,
      "y": 586.6208185166217
  },
  {
      "x": 714.2906089437494,
      "y": 586.6208185166217
  },
  {
      "x": 713.1900070809701,
      "y": 586.6208185166217
  },
  {
      "x": 710.9888033554115,
      "y": 587.7214204275347
  },
  {
      "x": 709.8882014926323,
      "y": 587.7214204275347
  },
  {
      "x": 708.787599629853,
      "y": 588.8220223384477
  },
  {
      "x": 707.6869977670738,
      "y": 588.8220223384477
  },
  {
      "x": 705.4857940415152,
      "y": 588.8220223384477
  },
  {
      "x": 704.3851921787359,
      "y": 588.8220223384477
  },
  {
      "x": 703.2845903159566,
      "y": 588.8220223384477
  },
  {
      "x": 701.083386590398,
      "y": 589.9226242493606
  },
  {
      "x": 699.9827847276188,
      "y": 589.9226242493606
  },
  {
      "x": 698.8821828648395,
      "y": 589.9226242493606
  },
  {
      "x": 694.4797754137225,
      "y": 589.9226242493606
  },
  {
      "x": 692.2785716881639,
      "y": 589.9226242493606
  },
  {
      "x": 691.1779698253846,
      "y": 589.9226242493606
  },
  {
      "x": 688.976766099826,
      "y": 589.9226242493606
  },
  {
      "x": 687.8761642370467,
      "y": 589.9226242493606
  },
  {
      "x": 686.7755623742676,
      "y": 589.9226242493606
  },
  {
      "x": 685.6749605114883,
      "y": 589.9226242493606
  },
  {
      "x": 682.3731549231504,
      "y": 589.9226242493606
  },
  {
      "x": 682.3731549231504,
      "y": 591.0232261602737
  },
  {
      "x": 680.1719511975919,
      "y": 591.0232261602737
  },
  {
      "x": 679.0713493348126,
      "y": 591.0232261602737
  },
  {
      "x": 677.9707474720333,
      "y": 591.0232261602737
  },
  {
      "x": 674.6689418836955,
      "y": 591.0232261602737
  },
  {
      "x": 673.5683400209163,
      "y": 591.0232261602737
  },
  {
      "x": 671.3671362953577,
      "y": 591.0232261602737
  },
  {
      "x": 669.1659325697991,
      "y": 591.0232261602737
  },
  {
      "x": 660.3611176675649,
      "y": 591.0232261602737
  },
  {
      "x": 655.9587102164478,
      "y": 591.0232261602737
  },
  {
      "x": 652.6569046281099,
      "y": 591.0232261602737
  },
  {
      "x": 650.4557009025515,
      "y": 591.0232261602737
  },
  {
      "x": 647.1538953142136,
      "y": 591.0232261602737
  },
  {
      "x": 644.9526915886551,
      "y": 591.0232261602737
  },
  {
      "x": 641.6508860003172,
      "y": 591.0232261602737
  },
  {
      "x": 636.1478766864209,
      "y": 591.0232261602737
  },
  {
      "x": 631.7454692353037,
      "y": 591.0232261602737
  },
  {
      "x": 629.5442655097452,
      "y": 591.0232261602737
  },
  {
      "x": 627.3430617841867,
      "y": 591.0232261602737
  },
  {
      "x": 625.1418580586281,
      "y": 591.0232261602737
  },
  {
      "x": 621.8400524702903,
      "y": 591.0232261602737
  },
  {
      "x": 619.6388487447317,
      "y": 591.0232261602737
  },
  {
      "x": 616.337043156394,
      "y": 591.0232261602737
  },
  {
      "x": 614.1358394308354,
      "y": 591.0232261602737
  },
  {
      "x": 611.9346357052768,
      "y": 591.0232261602737
  },
  {
      "x": 607.5322282541597,
      "y": 591.0232261602737
  },
  {
      "x": 606.4316263913804,
      "y": 591.0232261602737
  },
  {
      "x": 605.3310245286011,
      "y": 591.0232261602737
  },
  {
      "x": 602.0292189402634,
      "y": 591.0232261602737
  },
  {
      "x": 598.7274133519255,
      "y": 589.9226242493606
  },
  {
      "x": 596.526209626367,
      "y": 589.9226242493606
  },
  {
      "x": 594.3250059008084,
      "y": 589.9226242493606
  },
  {
      "x": 591.0232003124706,
      "y": 588.8220223384477
  },
  {
      "x": 588.8219965869121,
      "y": 588.8220223384477
  },
  {
      "x": 585.5201909985742,
      "y": 587.7214204275347
  },
  {
      "x": 581.1177835474571,
      "y": 586.6208185166217
  },
  {
      "x": 577.8159779591193,
      "y": 586.6208185166217
  },
  {
      "x": 576.71537609634,
      "y": 586.6208185166217
  },
  {
      "x": 572.3129686452229,
      "y": 585.5202166057087
  },
  {
      "x": 567.9105611941059,
      "y": 584.4196146947958
  },
  {
      "x": 565.7093574685473,
      "y": 584.4196146947958
  },
  {
      "x": 562.4075518802094,
      "y": 583.3190127838827
  },
  {
      "x": 559.1057462918716,
      "y": 583.3190127838827
  },
  {
      "x": 555.8039407035338,
      "y": 583.3190127838827
  },
  {
      "x": 553.6027369779753,
      "y": 583.3190127838827
  },
  {
      "x": 550.3009313896374,
      "y": 583.3190127838827
  },
  {
      "x": 546.9991258012996,
      "y": 583.3190127838827
  },
  {
      "x": 543.6973202129618,
      "y": 583.3190127838827
  },
  {
      "x": 541.4961164874032,
      "y": 583.3190127838827
  },
  {
      "x": 538.1943108990654,
      "y": 583.3190127838827
  },
  {
      "x": 535.9931071735068,
      "y": 582.2184108729698
  },
  {
      "x": 533.7919034479484,
      "y": 582.2184108729698
  },
  {
      "x": 531.5906997223898,
      "y": 582.2184108729698
  },
  {
      "x": 528.2888941340519,
      "y": 582.2184108729698
  },
  {
      "x": 526.0876904084934,
      "y": 582.2184108729698
  },
  {
      "x": 523.8864866829348,
      "y": 582.2184108729698
  },
  {
      "x": 519.4840792318178,
      "y": 582.2184108729698
  },
  {
      "x": 513.9810699179213,
      "y": 582.2184108729698
  },
  {
      "x": 507.37745874124573,
      "y": 582.2184108729698
  },
  {
      "x": 502.9750512901286,
      "y": 582.2184108729698
  },
  {
      "x": 500.7738475645701,
      "y": 582.2184108729698
  },
  {
      "x": 497.4720419762322,
      "y": 582.2184108729698
  },
  {
      "x": 495.2708382506737,
      "y": 582.2184108729698
  },
  {
      "x": 491.96903266233585,
      "y": 582.2184108729698
  },
  {
      "x": 488.66722707399805,
      "y": 582.2184108729698
  },
  {
      "x": 487.56662521121876,
      "y": 582.2184108729698
  },
  {
      "x": 484.26481962288096,
      "y": 582.2184108729698
  },
  {
      "x": 482.0636158973224,
      "y": 582.2184108729698
  },
  {
      "x": 479.8624121717638,
      "y": 582.2184108729698
  },
  {
      "x": 476.560606583426,
      "y": 582.2184108729698
  },
  {
      "x": 475.46000472064674,
      "y": 582.2184108729698
  },
  {
      "x": 473.25880099508817,
      "y": 582.2184108729698
  },
  {
      "x": 469.95699540675037,
      "y": 582.2184108729698
  },
  {
      "x": 467.7557916811918,
      "y": 582.2184108729698
  },
  {
      "x": 466.6551898184125,
      "y": 582.2184108729698
  },
  {
      "x": 463.3533842300747,
      "y": 582.2184108729698
  },
  {
      "x": 461.15218050451614,
      "y": 582.2184108729698
  },
  {
      "x": 458.9509767789576,
      "y": 582.2184108729698
  },
  {
      "x": 455.64917119061977,
      "y": 580.0172070511438
  },
  {
      "x": 452.34736560228197,
      "y": 580.0172070511438
  },
  {
      "x": 449.04556001394417,
      "y": 580.0172070511438
  },
  {
      "x": 444.643152562827,
      "y": 578.9166051402308
  },
  {
      "x": 441.3413469744892,
      "y": 577.8160032293179
  },
  {
      "x": 438.03954138615137,
      "y": 577.8160032293179
  },
  {
      "x": 435.83833766059286,
      "y": 577.8160032293179
  },
  {
      "x": 432.536532072255,
      "y": 576.7154013184048
  },
  {
      "x": 431.4359302094757,
      "y": 576.7154013184048
  },
  {
      "x": 428.1341246211379,
      "y": 575.6147994074919
  },
  {
      "x": 425.93292089557934,
      "y": 574.5141974965788
  },
  {
      "x": 424.8323190328001,
      "y": 573.4135955856659
  },
  {
      "x": 422.63111530724154,
      "y": 573.4135955856659
  },
  {
      "x": 420.429911581683,
      "y": 573.4135955856659
  },
  {
      "x": 418.22870785612446,
      "y": 572.3129936747529
  },
  {
      "x": 417.1281059933452,
      "y": 572.3129936747529
  },
  {
      "x": 413.8263004050074,
      "y": 571.21239176384
  },
  {
      "x": 413.8263004050074,
      "y": 570.1117898529269
  },
  {
      "x": 410.5244948166695,
      "y": 569.011187942014
  },
  {
      "x": 409.42389295389023,
      "y": 569.011187942014
  },
  {
      "x": 407.2226892283317,
      "y": 569.011187942014
  },
  {
      "x": 405.02148550277315,
      "y": 567.9105860311009
  },
  {
      "x": 400.61907805165606,
      "y": 564.608780298362
  },
  {
      "x": 396.2166706005389,
      "y": 563.508178387449
  },
  {
      "x": 394.0154668749804,
      "y": 562.407576476536
  },
  {
      "x": 391.81426314942183,
      "y": 561.306974565623
  },
  {
      "x": 389.6130594238633,
      "y": 560.20637265471
  },
  {
      "x": 387.41185569830475,
      "y": 560.20637265471
  },
  {
      "x": 384.11005010996695,
      "y": 558.005168832884
  },
  {
      "x": 383.00944824718766,
      "y": 555.803965011058
  },
  {
      "x": 379.7076426588498,
      "y": 555.803965011058
  },
  {
      "x": 377.5064389332913,
      "y": 554.7033631001451
  },
  {
      "x": 374.20463334495344,
      "y": 554.7033631001451
  },
  {
      "x": 373.10403148217415,
      "y": 553.6027611892321
  },
  {
      "x": 370.90282775661564,
      "y": 552.5021592783191
  },
  {
      "x": 368.70162403105707,
      "y": 551.4015573674061
  },
  {
      "x": 365.39981844271927,
      "y": 550.3009554564932
  },
  {
      "x": 363.1986147171607,
      "y": 550.3009554564932
  },
  {
      "x": 362.0980128543814,
      "y": 549.2003535455801
  },
  {
      "x": 360.9974109916021,
      "y": 549.2003535455801
  },
  {
      "x": 357.6956054032643,
      "y": 548.0997516346672
  },
  {
      "x": 356.59500354048504,
      "y": 548.0997516346672
  },
  {
      "x": 352.19259608936795,
      "y": 546.9991497237542
  },
  {
      "x": 348.89079050103015,
      "y": 546.9991497237542
  },
  {
      "x": 345.5889849126923,
      "y": 546.9991497237542
  },
  {
      "x": 343.3877811871338,
      "y": 546.9991497237542
  },
  {
      "x": 341.1865774615752,
      "y": 546.9991497237542
  },
  {
      "x": 338.98537373601664,
      "y": 546.9991497237542
  },
  {
      "x": 336.7841700104581,
      "y": 546.9991497237542
  },
  {
      "x": 335.68356814767884,
      "y": 546.9991497237542
  },
  {
      "x": 332.381762559341,
      "y": 546.9991497237542
  },
  {
      "x": 330.18055883378247,
      "y": 546.9991497237542
  },
  {
      "x": 325.7781513826653,
      "y": 546.9991497237542
  },
  {
      "x": 324.6775495198861,
      "y": 546.9991497237542
  },
  {
      "x": 320.27514206876896,
      "y": 546.9991497237542
  },
  {
      "x": 304.86671598985913,
      "y": 546.9991497237542
  },
  {
      "x": 300.46430853874205,
      "y": 546.9991497237542
  },
  {
      "x": 296.06190108762496,
      "y": 546.9991497237542
  },
  {
      "x": 293.8606973620664,
      "y": 546.9991497237542
  },
  {
      "x": 291.6594936365078,
      "y": 546.9991497237542
  },
  {
      "x": 288.35768804817,
      "y": 546.9991497237542
  },
  {
      "x": 286.15648432261145,
      "y": 546.9991497237542
  },
  {
      "x": 285.05588245983216,
      "y": 546.9991497237542
  },
  {
      "x": 279.5528731459358,
      "y": 546.9991497237542
  },
  {
      "x": 276.251067557598,
      "y": 546.9991497237542
  },
  {
      "x": 272.9492619692602,
      "y": 546.9991497237542
  },
  {
      "x": 271.8486601064809,
      "y": 546.9991497237542
  },
  {
      "x": 270.7480582437016,
      "y": 546.9991497237542
  },
  {
      "x": 268.54685451814305,
      "y": 546.9991497237542
  },
  {
      "x": 268.54685451814305,
      "y": 546.9991497237542
  },
  {
      "x": 266.34565079258454,
      "y": 546.9991497237542
  },
  {
      "x": 265.24504892980525,
      "y": 546.9991497237542
  },
  {
      "x": 264.14444706702596,
      "y": 546.9991497237542
  },
  {
      "x": 263.0438452042467,
      "y": 546.9991497237542
  },
  {
      "x": 261.9432433414674,
      "y": 546.9991497237542
  },
  {
      "x": 259.7420396159089,
      "y": 546.9991497237542
  },
  {
      "x": 256.440234027571,
      "y": 546.9991497237542
  },
  {
      "x": 255.33963216479177,
      "y": 546.9991497237542
  },
  {
      "x": 253.13842843923322,
      "y": 546.9991497237542
  },
  {
      "x": 250.93722471367465,
      "y": 548.0997516346672
  },
  {
      "x": 249.8366228508954,
      "y": 548.0997516346672
  },
  {
      "x": 248.7360209881161,
      "y": 549.2003535455801
  },
  {
      "x": 247.63541912533685,
      "y": 549.2003535455801
  },
  {
      "x": 246.53481726255757,
      "y": 550.3009554564932
  },
  {
      "x": 245.43421539977828,
      "y": 550.3009554564932
  },
  {
      "x": 243.23301167421974,
      "y": 551.4015573674061
  },
  {
      "x": 241.0318079486612,
      "y": 551.4015573674061
  },
  {
      "x": 238.83060422310265,
      "y": 552.5021592783191
  },
  {
      "x": 237.73000236032337,
      "y": 553.6027611892321
  },
  {
      "x": 236.62940049754408,
      "y": 553.6027611892321
  },
  {
      "x": 234.42819677198554,
      "y": 554.7033631001451
  },
  {
      "x": 234.42819677198554,
      "y": 555.803965011058
  },
  {
      "x": 232.226993046427,
      "y": 555.803965011058
  },
  {
      "x": 230.02578932086845,
      "y": 556.9045669219711
  },
  {
      "x": 228.92518745808917,
      "y": 558.005168832884
  },
  {
      "x": 227.82458559530988,
      "y": 559.105770743797
  },
  {
      "x": 224.52278000697208,
      "y": 560.20637265471
  },
  {
      "x": 224.52278000697208,
      "y": 560.20637265471
  },
  {
      "x": 222.3215762814135,
      "y": 560.20637265471
  },
  {
      "x": 220.12037255585497,
      "y": 561.306974565623
  },
  {
      "x": 219.01977069307569,
      "y": 562.407576476536
  },
  {
      "x": 219.01977069307569,
      "y": 563.508178387449
  },
  {
      "x": 216.81856696751714,
      "y": 564.608780298362
  },
  {
      "x": 215.71796510473786,
      "y": 564.608780298362
  },
  {
      "x": 214.6173632419586,
      "y": 564.608780298362
  },
  {
      "x": 212.41615951640006,
      "y": 565.709382209275
  },
  {
      "x": 210.2149557908415,
      "y": 566.809984120188
  },
  {
      "x": 208.01375206528294,
      "y": 569.011187942014
  },
  {
      "x": 206.9131502025037,
      "y": 570.1117898529269
  },
  {
      "x": 206.9131502025037,
      "y": 571.21239176384
  },
  {
      "x": 205.8125483397244,
      "y": 572.3129936747529
  },
  {
      "x": 204.71194647694512,
      "y": 572.3129936747529
  },
  {
      "x": 203.61134461416586,
      "y": 573.4135955856659
  },
  {
      "x": 203.61134461416586,
      "y": 573.4135955856659
  },
  {
      "x": 203.61134461416586,
      "y": 574.5141974965788
  },
  {
      "x": 203.61134461416586,
      "y": 576.7154013184048
  },
  {
      "x": 203.61134461416586,
      "y": 577.8160032293179
  },
  {
      "x": 203.61134461416586,
      "y": 577.8160032293179
  },
  {
      "x": 203.61134461416586,
      "y": 578.9166051402308
  },
  {
      "x": 203.61134461416586,
      "y": 581.1178089620568
  },
  {
      "x": 203.61134461416586,
      "y": 582.2184108729698
  },
  {
      "x": 203.61134461416586,
      "y": 585.5202166057087
  },
  {
      "x": 203.61134461416586,
      "y": 586.6208185166217
  },
  {
      "x": 203.61134461416586,
      "y": 587.7214204275347
  },
  {
      "x": 203.61134461416586,
      "y": 588.8220223384477
  },
  {
      "x": 203.61134461416586,
      "y": 589.9226242493606
  },
  {
      "x": 203.61134461416586,
      "y": 591.0232261602737
  },
  {
      "x": 203.61134461416586,
      "y": 592.1238280711866
  },
  {
      "x": 203.61134461416586,
      "y": 593.2244299820997
  },
  {
      "x": 204.71194647694512,
      "y": 594.3250318930126
  },
  {
      "x": 204.71194647694512,
      "y": 595.4256338039256
  },
  {
      "x": 205.8125483397244,
      "y": 596.5262357148385
  },
  {
      "x": 205.8125483397244,
      "y": 597.6268376257516
  },
  {
      "x": 205.8125483397244,
      "y": 598.7274395366645
  },
  {
      "x": 205.8125483397244,
      "y": 599.8280414475776
  },
  {
      "x": 206.9131502025037,
      "y": 602.0292452694035
  },
  {
      "x": 206.9131502025037,
      "y": 603.1298471803165
  },
  {
      "x": 206.9131502025037,
      "y": 604.2304490912295
  },
  {
      "x": 208.01375206528294,
      "y": 604.2304490912295
  },
  {
      "x": 208.01375206528294,
      "y": 604.2304490912295
  },
  {
      "x": 208.01375206528294,
      "y": 605.3310510021424
  },
  {
      "x": 210.2149557908415,
      "y": 606.4316529130555
  },
  {
      "x": 211.31555765362077,
      "y": 606.4316529130555
  },
  {
      "x": 211.31555765362077,
      "y": 607.5322548239684
  },
  {
      "x": 211.31555765362077,
      "y": 607.5322548239684
  },
  {
      "x": 212.41615951640006,
      "y": 608.6328567348814
  },
  {
      "x": 213.51676137917931,
      "y": 608.6328567348814
  },
  {
      "x": 216.81856696751714,
      "y": 608.6328567348814
  },
  {
      "x": 220.12037255585497,
      "y": 609.7334586457944
  },
  {
      "x": 221.22097441863426,
      "y": 609.7334586457944
  },
  {
      "x": 223.4221781441928,
      "y": 609.7334586457944
  },
  {
      "x": 226.72398373253063,
      "y": 609.7334586457944
  },
  {
      "x": 228.92518745808917,
      "y": 609.7334586457944
  },
  {
      "x": 230.02578932086845,
      "y": 609.7334586457944
  },
  {
      "x": 232.226993046427,
      "y": 610.8340605567074
  },
  {
      "x": 233.32759490920625,
      "y": 611.9346624676203
  },
  {
      "x": 235.52879863476483,
      "y": 613.0352643785334
  },
  {
      "x": 238.83060422310265,
      "y": 613.0352643785334
  },
  {
      "x": 245.43421539977828,
      "y": 613.0352643785334
  },
  {
      "x": 247.63541912533685,
      "y": 613.0352643785334
  },
  {
      "x": 250.93722471367465,
      "y": 613.0352643785334
  },
  {
      "x": 252.03782657645394,
      "y": 613.0352643785334
  },
  {
      "x": 255.33963216479177,
      "y": 613.0352643785334
  },
  {
      "x": 257.5408358903503,
      "y": 613.0352643785334
  },
  {
      "x": 259.7420396159089,
      "y": 613.0352643785334
  },
  {
      "x": 263.0438452042467,
      "y": 613.0352643785334
  },
  {
      "x": 266.34565079258454,
      "y": 613.0352643785334
  },
  {
      "x": 269.64745638092234,
      "y": 613.0352643785334
  },
  {
      "x": 271.8486601064809,
      "y": 613.0352643785334
  },
  {
      "x": 272.9492619692602,
      "y": 613.0352643785334
  },
  {
      "x": 276.251067557598,
      "y": 613.0352643785334
  },
  {
      "x": 277.3516694203773,
      "y": 613.0352643785334
  },
  {
      "x": 279.5528731459358,
      "y": 613.0352643785334
  },
  {
      "x": 280.6534750087151,
      "y": 613.0352643785334
  },
  {
      "x": 281.75407687149436,
      "y": 613.0352643785334
  },
  {
      "x": 285.05588245983216,
      "y": 613.0352643785334
  },
  {
      "x": 286.15648432261145,
      "y": 613.0352643785334
  },
  {
      "x": 290.55889177372853,
      "y": 613.0352643785334
  },
  {
      "x": 293.8606973620664,
      "y": 613.0352643785334
  },
  {
      "x": 297.1625029504042,
      "y": 613.0352643785334
  },
  {
      "x": 299.36370667596276,
      "y": 613.0352643785334
  },
  {
      "x": 301.56491040152133,
      "y": 613.0352643785334
  },
  {
      "x": 305.9673178526384,
      "y": 613.0352643785334
  },
  {
      "x": 308.168521578197,
      "y": 613.0352643785334
  },
  {
      "x": 309.2691234409762,
      "y": 613.0352643785334
  },
  {
      "x": 311.4703271665348,
      "y": 613.0352643785334
  },
  {
      "x": 313.67153089209336,
      "y": 613.0352643785334
  },
  {
      "x": 316.97333648043116,
      "y": 613.0352643785334
  },
  {
      "x": 319.17454020598973,
      "y": 613.0352643785334
  },
  {
      "x": 321.37574393154824,
      "y": 613.0352643785334
  },
  {
      "x": 325.7781513826653,
      "y": 613.0352643785334
  },
  {
      "x": 329.0799569710032,
      "y": 613.0352643785334
  },
  {
      "x": 330.18055883378247,
      "y": 613.0352643785334
  },
  {
      "x": 332.381762559341,
      "y": 613.0352643785334
  },
  {
      "x": 335.68356814767884,
      "y": 613.0352643785334
  },
  {
      "x": 338.98537373601664,
      "y": 613.0352643785334
  },
  {
      "x": 338.98537373601664,
      "y": 613.0352643785334
  },
  {
      "x": 344.488383049913,
      "y": 613.0352643785334
  },
  {
      "x": 348.89079050103015,
      "y": 613.0352643785334
  },
  {
      "x": 353.29319795214724,
      "y": 613.0352643785334
  },
  {
      "x": 354.3937998149265,
      "y": 613.0352643785334
  },
  {
      "x": 356.59500354048504,
      "y": 613.0352643785334
  },
  {
      "x": 358.7962072660436,
      "y": 613.0352643785334
  },
  {
      "x": 360.9974109916021,
      "y": 613.0352643785334
  },
  {
      "x": 363.1986147171607,
      "y": 613.0352643785334
  },
  {
      "x": 365.39981844271927,
      "y": 613.0352643785334
  },
  {
      "x": 368.70162403105707,
      "y": 611.9346624676203
  },
  {
      "x": 369.80222589383635,
      "y": 610.8340605567074
  },
  {
      "x": 373.10403148217415,
      "y": 610.8340605567074
  },
  {
      "x": 375.3052352077327,
      "y": 609.7334586457944
  },
  {
      "x": 377.5064389332913,
      "y": 608.6328567348814
  },
  {
      "x": 380.8082445216291,
      "y": 608.6328567348814
  },
  {
      "x": 383.00944824718766,
      "y": 608.6328567348814
  },
  {
      "x": 385.2106519727462,
      "y": 607.5322548239684
  },
  {
      "x": 387.41185569830475,
      "y": 607.5322548239684
  },
  {
      "x": 390.71366128664255,
      "y": 606.4316529130555
  },
  {
      "x": 391.81426314942183,
      "y": 605.3310510021424
  },
  {
      "x": 392.9148650122011,
      "y": 605.3310510021424
  },
  {
      "x": 396.2166706005389,
      "y": 605.3310510021424
  },
  {
      "x": 397.3172724633182,
      "y": 605.3310510021424
  },
  {
      "x": 398.4178743260975,
      "y": 605.3310510021424
  },
  {
      "x": 403.92088363999386,
      "y": 604.2304490912295
  },
  {
      "x": 405.02148550277315,
      "y": 604.2304490912295
  },
  {
      "x": 407.2226892283317,
      "y": 603.1298471803165
  },
  {
      "x": 409.42389295389023,
      "y": 603.1298471803165
  },
  {
      "x": 411.6250966794488,
      "y": 602.0292452694035
  },
  {
      "x": 413.8263004050074,
      "y": 602.0292452694035
  },
  {
      "x": 416.0275041305659,
      "y": 600.9286433584905
  },
  {
      "x": 418.22870785612446,
      "y": 599.8280414475776
  },
  {
      "x": 422.63111530724154,
      "y": 599.8280414475776
  },
  {
      "x": 425.93292089557934,
      "y": 597.6268376257516
  },
  {
      "x": 427.03352275835863,
      "y": 596.5262357148385
  },
  {
      "x": 431.4359302094757,
      "y": 595.4256338039256
  },
  {
      "x": 432.536532072255,
      "y": 594.3250318930126
  },
  {
      "x": 435.83833766059286,
      "y": 593.2244299820997
  },
  {
      "x": 439.14014324893066,
      "y": 592.1238280711866
  },
  {
      "x": 440.24074511170994,
      "y": 592.1238280711866
  },
  {
      "x": 441.3413469744892,
      "y": 592.1238280711866
  },
  {
      "x": 443.54255070004774,
      "y": 591.0232261602737
  },
  {
      "x": 444.643152562827,
      "y": 589.9226242493606
  },
  {
      "x": 447.9449581511649,
      "y": 588.8220223384477
  },
  {
      "x": 449.04556001394417,
      "y": 588.8220223384477
  },
  {
      "x": 450.1461618767234,
      "y": 587.7214204275347
  },
  {
      "x": 452.34736560228197,
      "y": 586.6208185166217
  },
  {
      "x": 453.44796746506125,
      "y": 586.6208185166217
  },
  {
      "x": 456.74977305339905,
      "y": 586.6208185166217
  },
  {
      "x": 458.9509767789576,
      "y": 586.6208185166217
  },
  {
      "x": 460.0515786417369,
      "y": 585.5202166057087
  },
  {
      "x": 462.2527823672954,
      "y": 584.4196146947958
  },
  {
      "x": 464.453986092854,
      "y": 584.4196146947958
  },
  {
      "x": 465.5545879556333,
      "y": 583.3190127838827
  },
  {
      "x": 466.6551898184125,
      "y": 582.2184108729698
  },
  {
      "x": 468.8563935439711,
      "y": 582.2184108729698
  },
  {
      "x": 471.05759726952965,
      "y": 581.1178089620568
  },
  {
      "x": 471.05759726952965,
      "y": 581.1178089620568
  },
  {
      "x": 473.25880099508817,
      "y": 580.0172070511438
  },
  {
      "x": 474.35940285786745,
      "y": 580.0172070511438
  },
  {
      "x": 475.46000472064674,
      "y": 578.9166051402308
  },
  {
      "x": 476.560606583426,
      "y": 577.8160032293179
  },
  {
      "x": 477.6612084462053,
      "y": 577.8160032293179
  },
  {
      "x": 479.8624121717638,
      "y": 577.8160032293179
  },
  {
      "x": 480.9630140345431,
      "y": 577.8160032293179
  },
  {
      "x": 483.1642177601017,
      "y": 575.6147994074919
  },
  {
      "x": 484.26481962288096,
      "y": 575.6147994074919
  },
  {
      "x": 486.4660233484395,
      "y": 574.5141974965788
  },
  {
      "x": 486.4660233484395,
      "y": 573.4135955856659
  },
  {
      "x": 487.56662521121876,
      "y": 573.4135955856659
  },
  {
      "x": 488.66722707399805,
      "y": 573.4135955856659
  },
  {
      "x": 489.76782893677733,
      "y": 572.3129936747529
  },
  {
      "x": 491.96903266233585,
      "y": 572.3129936747529
  },
  {
      "x": 493.06963452511513,
      "y": 572.3129936747529
  },
  {
      "x": 493.06963452511513,
      "y": 572.3129936747529
  },
  {
      "x": 495.2708382506737,
      "y": 571.21239176384
  },
  {
      "x": 495.2708382506737,
      "y": 570.1117898529269
  },
  {
      "x": 497.4720419762322,
      "y": 569.011187942014
  },
  {
      "x": 499.6732457017908,
      "y": 569.011187942014
  },
  {
      "x": 500.7738475645701,
      "y": 567.9105860311009
  },
  {
      "x": 501.8744494273493,
      "y": 566.809984120188
  },
  {
      "x": 502.9750512901286,
      "y": 565.709382209275
  },
  {
      "x": 504.0756531529079,
      "y": 564.608780298362
  },
  {
      "x": 505.17625501568716,
      "y": 564.608780298362
  },
  {
      "x": 507.37745874124573,
      "y": 564.608780298362
  },
  {
      "x": 510.67926432958353,
      "y": 561.306974565623
  },
  {
      "x": 511.7798661923628,
      "y": 560.20637265471
  },
  {
      "x": 513.9810699179213,
      "y": 560.20637265471
  },
  {
      "x": 516.1822736434799,
      "y": 560.20637265471
  },
  {
      "x": 518.3834773690385,
      "y": 559.105770743797
  },
  {
      "x": 519.4840792318178,
      "y": 556.9045669219711
  },
  {
      "x": 521.6852829573763,
      "y": 555.803965011058
  },
  {
      "x": 523.8864866829348,
      "y": 555.803965011058
  },
  {
      "x": 527.1882922712726,
      "y": 553.6027611892321
  },
  {
      "x": 528.2888941340519,
      "y": 552.5021592783191
  },
  {
      "x": 530.4900978596105,
      "y": 551.4015573674061
  },
  {
      "x": 532.6913015851691,
      "y": 551.4015573674061
  },
  {
      "x": 534.8925053107275,
      "y": 550.3009554564932
  },
  {
      "x": 537.0937090362861,
      "y": 549.2003535455801
  },
  {
      "x": 538.1943108990654,
      "y": 548.0997516346672
  },
  {
      "x": 541.4961164874032,
      "y": 546.9991497237542
  },
  {
      "x": 542.5967183501825,
      "y": 545.8985478128412
  },
  {
      "x": 545.8985239385204,
      "y": 543.6973439910153
  },
  {
      "x": 545.8985239385204,
      "y": 542.5967420801022
  },
  {
      "x": 548.0997276640788,
      "y": 542.5967420801022
  },
  {
      "x": 550.3009313896374,
      "y": 542.5967420801022
  },
  {
      "x": 550.3009313896374,
      "y": 541.4961401691893
  },
  {
      "x": 553.6027369779753,
      "y": 540.3955382582762
  },
  {
      "x": 556.9045425663131,
      "y": 538.1943344364503
  },
  {
      "x": 559.1057462918716,
      "y": 538.1943344364503
  },
  {
      "x": 559.1057462918716,
      "y": 537.0937325255373
  },
  {
      "x": 562.4075518802094,
      "y": 535.9931306146243
  },
  {
      "x": 563.5081537429887,
      "y": 535.9931306146243
  },
  {
      "x": 563.5081537429887,
      "y": 534.8925287037114
  },
  {
      "x": 566.8099593313266,
      "y": 533.7919267927983
  },
  {
      "x": 567.9105611941059,
      "y": 533.7919267927983
  },
  {
      "x": 569.0111630568852,
      "y": 532.6913248818854
  },
  {
      "x": 571.2123667824436,
      "y": 531.5907229709724
  },
  {
      "x": 572.3129686452229,
      "y": 530.4901210600594
  },
  {
      "x": 573.4135705080022,
      "y": 529.3895191491464
  },
  {
      "x": 575.6147742335608,
      "y": 529.3895191491464
  },
  {
      "x": 576.71537609634,
      "y": 527.1883153273204
  },
  {
      "x": 578.9165798218986,
      "y": 526.0877134164075
  },
  {
      "x": 581.1177835474571,
      "y": 524.9871115054945
  },
  {
      "x": 582.2183854102364,
      "y": 523.8865095945815
  },
  {
      "x": 584.4195891357949,
      "y": 523.8865095945815
  },
  {
      "x": 585.5201909985742,
      "y": 522.7859076836685
  },
  {
      "x": 594.3250059008084,
      "y": 518.3835000400165
  },
  {
      "x": 598.7274133519255,
      "y": 516.1822962181906
  },
  {
      "x": 598.7274133519255,
      "y": 516.1822962181906
  },
  {
      "x": 600.9286170774841,
      "y": 515.0816943072776
  },
  {
      "x": 603.1298208030427,
      "y": 512.8804904854517
  },
  {
      "x": 605.3310245286011,
      "y": 511.77988857453863
  },
  {
      "x": 606.4316263913804,
      "y": 510.67928666362565
  },
  {
      "x": 607.5322282541597,
      "y": 509.57868475271266
  },
  {
      "x": 609.7334319797183,
      "y": 508.4780828417997
  },
  {
      "x": 610.8340338424975,
      "y": 508.4780828417997
  },
  {
      "x": 613.0352375680561,
      "y": 507.3774809308867
  },
  {
      "x": 614.1358394308354,
      "y": 506.2768790199737
  },
  {
      "x": 615.2364412936147,
      "y": 505.1762771090607
  },
  {
      "x": 616.337043156394,
      "y": 502.97507328723475
  },
  {
      "x": 618.5382468819524,
      "y": 502.97507328723475
  },
  {
      "x": 620.739450607511,
      "y": 501.87447137632176
  },
  {
      "x": 621.8400524702903,
      "y": 500.7738694654088
  },
  {
      "x": 624.0412561958489,
      "y": 499.6732675544958
  },
  {
      "x": 625.1418580586281,
      "y": 498.5726656435828
  },
  {
      "x": 626.2424599214074,
      "y": 498.5726656435828
  },
  {
      "x": 627.3430617841867,
      "y": 497.4720637326698
  },
  {
      "x": 629.5442655097452,
      "y": 497.4720637326698
  },
  {
      "x": 629.5442655097452,
      "y": 496.37146182175684
  },
  {
      "x": 631.7454692353037,
      "y": 495.27085991084385
  },
  {
      "x": 633.9466729608623,
      "y": 494.17025799993087
  },
  {
      "x": 638.3490804119795,
      "y": 493.0696560890179
  },
  {
      "x": 640.5502841375379,
      "y": 489.7678503562789
  },
  {
      "x": 642.7514878630965,
      "y": 489.7678503562789
  },
  {
      "x": 644.9526915886551,
      "y": 487.56664653445296
  },
  {
      "x": 646.0532934514343,
      "y": 486.46604462354
  },
  {
      "x": 648.2544971769929,
      "y": 485.365442712627
  },
  {
      "x": 651.5563027653307,
      "y": 484.264840801714
  },
  {
      "x": 653.7575064908892,
      "y": 482.06363697988803
  },
  {
      "x": 655.9587102164478,
      "y": 480.96303506897505
  },
  {
      "x": 657.0593120792271,
      "y": 480.96303506897505
  },
  {
      "x": 660.3611176675649,
      "y": 478.761831247149
  },
  {
      "x": 660.3611176675649,
      "y": 478.761831247149
  },
  {
      "x": 661.4617195303442,
      "y": 477.66122933623603
  },
  {
      "x": 662.5623213931235,
      "y": 477.66122933623603
  },
  {
      "x": 665.8641269814613,
      "y": 476.56062742532305
  },
  {
      "x": 669.1659325697991,
      "y": 476.56062742532305
  },
  {
      "x": 670.2665344325784,
      "y": 475.46002551441006
  },
  {
      "x": 672.467738158137,
      "y": 475.46002551441006
  },
  {
      "x": 675.7695437464747,
      "y": 474.3594236034971
  },
  {
      "x": 677.9707474720333,
      "y": 473.2588216925841
  },
  {
      "x": 680.1719511975919,
      "y": 472.1582197816711
  },
  {
      "x": 682.3731549231504,
      "y": 472.1582197816711
  },
  {
      "x": 690.0773679626053,
      "y": 471.0576178707581
  },
  {
      "x": 692.2785716881639,
      "y": 469.95701595984514
  },
  {
      "x": 694.4797754137225,
      "y": 468.85641404893215
  },
  {
      "x": 697.7815810020603,
      "y": 467.75581213801917
  },
  {
      "x": 701.083386590398,
      "y": 467.75581213801917
  },
  {
      "x": 704.3851921787359,
      "y": 467.75581213801917
  },
  {
      "x": 708.787599629853,
      "y": 466.6552102271062
  },
  {
      "x": 712.0894052181908,
      "y": 465.5546083161932
  },
  {
      "x": 714.2906089437494,
      "y": 464.4540064052802
  },
  {
      "x": 717.5924145320872,
      "y": 463.3534044943672
  },
  {
      "x": 720.8942201204251,
      "y": 463.3534044943672
  },
  {
      "x": 723.0954238459835,
      "y": 462.25280258345424
  },
  {
      "x": 726.3972294343214,
      "y": 460.05159876162827
  },
  {
      "x": 730.7996368854385,
      "y": 458.9509968507153
  },
  {
      "x": 733.0008406109971,
      "y": 458.9509968507153
  },
  {
      "x": 736.3026461993348,
      "y": 458.9509968507153
  },
  {
      "x": 739.6044517876727,
      "y": 457.8503949398023
  },
  {
      "x": 744.0068592387898,
      "y": 456.7497930288893
  },
  {
      "x": 747.3086648271276,
      "y": 455.64919111797633
  },
  {
      "x": 748.4092666899069,
      "y": 454.54858920706334
  },
  {
      "x": 752.811674141024,
      "y": 453.44798729615036
  },
  {
      "x": 755.0128778665826,
      "y": 452.3473853852374
  },
  {
      "x": 757.2140815921412,
      "y": 452.3473853852374
  },
  {
      "x": 762.7170909060375,
      "y": 452.3473853852374
  },
  {
      "x": 767.1194983571546,
      "y": 450.1461815634114
  },
  {
      "x": 770.4213039454924,
      "y": 450.1461815634114
  },
  {
      "x": 770.4213039454924,
      "y": 450.1461815634114
  },
  {
      "x": 774.8237113966095,
      "y": 447.94497774158543
  },
  {
      "x": 775.9243132593888,
      "y": 445.74377391975946
  },
  {
      "x": 779.2261188477266,
      "y": 445.74377391975946
  },
  {
      "x": 780.3267207105059,
      "y": 443.5425700979335
  },
  {
      "x": 782.5279244360644,
      "y": 442.4419681870205
  },
  {
      "x": 783.6285262988437,
      "y": 442.4419681870205
  },
  {
      "x": 785.8297300244022,
      "y": 441.3413662761075
  },
  {
      "x": 786.9303318871815,
      "y": 441.3413662761075
  },
  {
      "x": 789.1315356127401,
      "y": 439.14016245428155
  },
  {
      "x": 791.3327393382987,
      "y": 439.14016245428155
  },
  {
      "x": 792.4333412010778,
      "y": 438.03956054336857
  },
  {
      "x": 793.5339430638571,
      "y": 436.9389586324556
  },
  {
      "x": 796.835748652195,
      "y": 435.8383567215426
  },
  {
      "x": 797.9363505149743,
      "y": 435.8383567215426
  },
  {
      "x": 799.0369523777536,
      "y": 435.8383567215426
  },
  {
      "x": 801.2381561033121,
      "y": 434.7377548106296
  },
  {
      "x": 805.6405635544291,
      "y": 432.53655098880364
  },
  {
      "x": 808.942369142767,
      "y": 430.33534716697767
  },
  {
      "x": 810.0429710055463,
      "y": 429.2347452560647
  },
  {
      "x": 813.3447765938841,
      "y": 428.1341433451517
  },
  {
      "x": 814.4453784566634,
      "y": 428.1341433451517
  },
  {
      "x": 816.6465821822219,
      "y": 428.1341433451517
  },
  {
      "x": 818.8477859077805,
      "y": 428.1341433451517
  },
  {
      "x": 819.9483877705597,
      "y": 428.1341433451517
  },
  {
      "x": 822.1495914961183,
      "y": 427.0335414342387
  },
  {
      "x": 823.2501933588976,
      "y": 427.0335414342387
  },
  {
      "x": 825.4513970844562,
      "y": 427.0335414342387
  },
  {
      "x": 826.5519989472355,
      "y": 427.0335414342387
  },
  {
      "x": 827.6526008100147,
      "y": 427.0335414342387
  },
  {
      "x": 828.7532026727939,
      "y": 425.93293952332573
  },
  {
      "x": 829.8538045355732,
      "y": 425.93293952332573
  },
  {
      "x": 830.9544063983525,
      "y": 425.93293952332573
  },
  {
      "x": 832.0550082611318,
      "y": 424.83233761241274
  },
  {
      "x": 833.1556101239111,
      "y": 424.83233761241274
  },
  {
      "x": 835.3568138494696,
      "y": 424.83233761241274
  },
  {
      "x": 836.4574157122489,
      "y": 424.83233761241274
  },
  {
      "x": 837.5580175750282,
      "y": 424.83233761241274
  },
  {
      "x": 840.859823163366,
      "y": 424.83233761241274
  },
  {
      "x": 841.9604250261452,
      "y": 424.83233761241274
  },
  {
      "x": 844.1616287517038,
      "y": 424.83233761241274
  },
  {
      "x": 845.2622306144831,
      "y": 424.83233761241274
  },
  {
      "x": 845.2622306144831,
      "y": 424.83233761241274
  },
  {
      "x": 846.3628324772624,
      "y": 424.83233761241274
  },
  {
      "x": 847.4634343400417,
      "y": 424.83233761241274
  },
  {
      "x": 848.564036202821,
      "y": 424.83233761241274
  },
  {
      "x": 849.6646380656002,
      "y": 424.83233761241274
  },
  {
      "x": 849.6646380656002,
      "y": 424.83233761241274
  },
  {
      "x": 852.966443653938,
      "y": 424.83233761241274
  },
  {
      "x": 855.1676473794965,
      "y": 425.93293952332573
  },
  {
      "x": 858.4694529678344,
      "y": 427.0335414342387
  },
  {
      "x": 859.5700548306137,
      "y": 427.0335414342387
  },
  {
      "x": 860.670656693393,
      "y": 427.0335414342387
  },
  {
      "x": 861.7712585561723,
      "y": 428.1341433451517
  },
  {
      "x": 862.8718604189514,
      "y": 428.1341433451517
  },
  {
      "x": 862.8718604189514,
      "y": 428.1341433451517
  },
  {
      "x": 863.9724622817307,
      "y": 429.2347452560647
  },
  {
      "x": 865.07306414451,
      "y": 429.2347452560647
  },
  {
      "x": 866.1736660072893,
      "y": 429.2347452560647
  },
  {
      "x": 867.2742678700686,
      "y": 430.33534716697767
  },
  {
      "x": 867.2742678700686,
      "y": 430.33534716697767
  },
  {
      "x": 868.3748697328479,
      "y": 430.33534716697767
  },
  {
      "x": 869.4754715956271,
      "y": 431.43594907789065
  },
  {
      "x": 870.5760734584064,
      "y": 432.53655098880364
  },
  {
      "x": 871.6766753211857,
      "y": 432.53655098880364
  },
  {
      "x": 871.6766753211857,
      "y": 432.53655098880364
  },
  {
      "x": 872.777277183965,
      "y": 433.6371528997166
  },
  {
      "x": 873.8778790467443,
      "y": 434.7377548106296
  },
  {
      "x": 874.9784809095235,
      "y": 434.7377548106296
  },
  {
      "x": 876.0790827723027,
      "y": 434.7377548106296
  },
  {
      "x": 878.2802864978613,
      "y": 435.8383567215426
  },
  {
      "x": 879.3808883606406,
      "y": 435.8383567215426
  },
  {
      "x": 879.3808883606406,
      "y": 436.9389586324556
  },
  {
      "x": 880.4814902234199,
      "y": 436.9389586324556
  },
  {
      "x": 880.4814902234199,
      "y": 436.9389586324556
  },
  {
      "x": 881.5820920861992,
      "y": 436.9389586324556
  },
  {
      "x": 882.6826939489785,
      "y": 438.03956054336857
  },
  {
      "x": 883.7832958117577,
      "y": 438.03956054336857
  },
  {
      "x": 883.7832958117577,
      "y": 439.14016245428155
  },
  {
      "x": 884.883897674537,
      "y": 439.14016245428155
  },
  {
      "x": 885.9844995373163,
      "y": 440.24076436519454
  },
  {
      "x": 885.9844995373163,
      "y": 441.3413662761075
  },
  {
      "x": 887.0851014000955,
      "y": 441.3413662761075
  },
  {
      "x": 888.1857032628748,
      "y": 442.4419681870205
  },
  {
      "x": 888.1857032628748,
      "y": 443.5425700979335
  },
  {
      "x": 888.1857032628748,
      "y": 444.6431720088465
  },
  {
      "x": 888.1857032628748,
      "y": 445.74377391975946
  },
  {
      "x": 888.1857032628748,
      "y": 445.74377391975946
  },
  {
      "x": 888.1857032628748,
      "y": 446.84437583067245
  },
  {
      "x": 888.1857032628748,
      "y": 447.94497774158543
  },
  {
      "x": 888.1857032628748,
      "y": 449.0455796524984
  },
  {
      "x": 888.1857032628748,
      "y": 450.1461815634114
  },
  {
      "x": 888.1857032628748,
      "y": 450.1461815634114
  },
  {
      "x": 888.1857032628748,
      "y": 451.2467834743244
  },
  {
      "x": 888.1857032628748,
      "y": 452.3473853852374
  },
  {
      "x": 888.1857032628748,
      "y": 453.44798729615036
  },
  {
      "x": 888.1857032628748,
      "y": 454.54858920706334
  },
  {
      "x": 887.0851014000955,
      "y": 454.54858920706334
  },
  {
      "x": 885.9844995373163,
      "y": 455.64919111797633
  },
  {
      "x": 885.9844995373163,
      "y": 456.7497930288893
  },
  {
      "x": 884.883897674537,
      "y": 457.8503949398023
  },
  {
      "x": 884.883897674537,
      "y": 458.9509968507153
  },
  {
      "x": 884.883897674537,
      "y": 460.05159876162827
  },
  {
      "x": 883.7832958117577,
      "y": 461.15220067254126
  },
  {
      "x": 882.6826939489785,
      "y": 461.15220067254126
  },
  {
      "x": 882.6826939489785,
      "y": 462.25280258345424
  },
  {
      "x": 881.5820920861992,
      "y": 463.3534044943672
  },
  {
      "x": 881.5820920861992,
      "y": 463.3534044943672
  },
  {
      "x": 880.4814902234199,
      "y": 464.4540064052802
  },
  {
      "x": 880.4814902234199,
      "y": 465.5546083161932
  },
  {
      "x": 878.2802864978613,
      "y": 466.6552102271062
  },
  {
      "x": 877.179684635082,
      "y": 467.75581213801917
  },
  {
      "x": 876.0790827723027,
      "y": 467.75581213801917
  },
  {
      "x": 876.0790827723027,
      "y": 468.85641404893215
  },
  {
      "x": 873.8778790467443,
      "y": 469.95701595984514
  },
  {
      "x": 872.777277183965,
      "y": 469.95701595984514
  },
  {
      "x": 872.777277183965,
      "y": 471.0576178707581
  },
  {
      "x": 871.6766753211857,
      "y": 472.1582197816711
  },
  {
      "x": 871.6766753211857,
      "y": 472.1582197816711
  },
  {
      "x": 871.6766753211857,
      "y": 472.1582197816711
  },
  {
      "x": 866.1736660072893,
      "y": 475.46002551441006
  },
  {
      "x": 862.8718604189514,
      "y": 476.56062742532305
  },
  {
      "x": 861.7712585561723,
      "y": 476.56062742532305
  },
  {
      "x": 860.670656693393,
      "y": 476.56062742532305
  },
  {
      "x": 859.5700548306137,
      "y": 477.66122933623603
  },
  {
      "x": 858.4694529678344,
      "y": 478.761831247149
  },
  {
      "x": 858.4694529678344,
      "y": 478.761831247149
  },
  {
      "x": 857.3688511050551,
      "y": 478.761831247149
  },
  {
      "x": 856.2682492422758,
      "y": 478.761831247149
  },
  {
      "x": 854.0670455167173,
      "y": 478.761831247149
  },
  {
      "x": 854.0670455167173,
      "y": 478.761831247149
  },
  {
      "x": 851.8658417911587,
      "y": 480.96303506897505
  },
  {
      "x": 849.6646380656002,
      "y": 480.96303506897505
  },
  {
      "x": 849.6646380656002,
      "y": 480.96303506897505
  },
  {
      "x": 848.564036202821,
      "y": 482.06363697988803
  },
  {
      "x": 846.3628324772624,
      "y": 482.06363697988803
  },
  {
      "x": 845.2622306144831,
      "y": 482.06363697988803
  },
  {
      "x": 845.2622306144831,
      "y": 482.06363697988803
  },
  {
      "x": 843.0610268889245,
      "y": 482.06363697988803
  },
  {
      "x": 840.859823163366,
      "y": 483.164238890801
  },
  {
      "x": 839.7592213005867,
      "y": 484.264840801714
  },
  {
      "x": 838.6586194378075,
      "y": 484.264840801714
  },
  {
      "x": 836.4574157122489,
      "y": 485.365442712627
  },
  {
      "x": 836.4574157122489,
      "y": 485.365442712627
  },
  {
      "x": 834.2562119866903,
      "y": 485.365442712627
  },
  {
      "x": 833.1556101239111,
      "y": 485.365442712627
  },
  {
      "x": 832.0550082611318,
      "y": 485.365442712627
  },
  {
      "x": 828.7532026727939,
      "y": 485.365442712627
  },
  {
      "x": 827.6526008100147,
      "y": 485.365442712627
  },
  {
      "x": 825.4513970844562,
      "y": 485.365442712627
  },
  {
      "x": 824.3507952216769,
      "y": 485.365442712627
  },
  {
      "x": 823.2501933588976,
      "y": 485.365442712627
  },
  {
      "x": 823.2501933588976,
      "y": 485.365442712627
  },
  {
      "x": 821.048989633339,
      "y": 485.365442712627
  },
  {
      "x": 818.8477859077805,
      "y": 485.365442712627
  },
  {
      "x": 818.8477859077805,
      "y": 485.365442712627
  },
  {
      "x": 816.6465821822219,
      "y": 485.365442712627
  },
  {
      "x": 814.4453784566634,
      "y": 485.365442712627
  },
  {
      "x": 812.2441747311049,
      "y": 485.365442712627
  },
  {
      "x": 810.0429710055463,
      "y": 485.365442712627
  },
  {
      "x": 806.7411654172084,
      "y": 485.365442712627
  },
  {
      "x": 805.6405635544291,
      "y": 485.365442712627
  },
  {
      "x": 804.5399616916499,
      "y": 485.365442712627
  },
  {
      "x": 803.4393598288707,
      "y": 485.365442712627
  },
  {
      "x": 801.2381561033121,
      "y": 485.365442712627
  },
  {
      "x": 799.0369523777536,
      "y": 485.365442712627
  },
  {
      "x": 797.9363505149743,
      "y": 485.365442712627
  },
  {
      "x": 796.835748652195,
      "y": 484.264840801714
  },
  {
      "x": 793.5339430638571,
      "y": 484.264840801714
  },
  {
      "x": 792.4333412010778,
      "y": 483.164238890801
  },
  {
      "x": 790.2321374755194,
      "y": 483.164238890801
  },
  {
      "x": 788.0309337499608,
      "y": 482.06363697988803
  },
  {
      "x": 786.9303318871815,
      "y": 482.06363697988803
  },
  {
      "x": 784.729128161623,
      "y": 480.96303506897505
  },
  {
      "x": 783.6285262988437,
      "y": 480.96303506897505
  },
  {
      "x": 781.4273225732851,
      "y": 480.96303506897505
  },
  {
      "x": 780.3267207105059,
      "y": 479.86243315806206
  },
  {
      "x": 778.1255169849474,
      "y": 479.86243315806206
  },
  {
      "x": 775.9243132593888,
      "y": 478.761831247149
  },
  {
      "x": 774.8237113966095,
      "y": 478.761831247149
  },
  {
      "x": 771.5219058082716,
      "y": 478.761831247149
  },
  {
      "x": 770.4213039454924,
      "y": 477.66122933623603
  },
  {
      "x": 769.3207020827131,
      "y": 477.66122933623603
  },
  {
      "x": 766.0188964943753,
      "y": 476.56062742532305
  },
  {
      "x": 764.918294631596,
      "y": 476.56062742532305
  },
  {
      "x": 763.8176927688168,
      "y": 476.56062742532305
  },
  {
      "x": 762.7170909060375,
      "y": 476.56062742532305
  },
  {
      "x": 761.6164890432582,
      "y": 475.46002551441006
  },
  {
      "x": 760.5158871804789,
      "y": 475.46002551441006
  },
  {
      "x": 758.3146834549203,
      "y": 475.46002551441006
  },
  {
      "x": 757.2140815921412,
      "y": 475.46002551441006
  },
  {
      "x": 757.2140815921412,
      "y": 474.3594236034971
  },
  {
      "x": 756.1134797293619,
      "y": 473.2588216925841
  },
  {
      "x": 756.1134797293619,
      "y": 472.1582197816711
  },
  {
      "x": 755.0128778665826,
      "y": 472.1582197816711
  },
  {
      "x": 752.811674141024,
      "y": 472.1582197816711
  },
  {
      "x": 752.811674141024,
      "y": 471.0576178707581
  },
  {
      "x": 752.811674141024,
      "y": 471.0576178707581
  },
  {
      "x": 751.7110722782447,
      "y": 469.95701595984514
  },
  {
      "x": 750.6104704154654,
      "y": 469.95701595984514
  },
  {
      "x": 749.5098685526862,
      "y": 468.85641404893215
  },
  {
      "x": 748.4092666899069,
      "y": 467.75581213801917
  },
  {
      "x": 747.3086648271276,
      "y": 467.75581213801917
  },
  {
      "x": 746.2080629643483,
      "y": 467.75581213801917
  },
  {
      "x": 745.1074611015691,
      "y": 467.75581213801917
  },
  {
      "x": 744.0068592387898,
      "y": 467.75581213801917
  }
]